export default {
  // Navigation
  nav: {
    trade: 'Trading',
    dashboard: 'Tableau de bord',
    chart: 'Graphique',
    logs: 'Logs',
    settings: 'Paramètres',
    backtest: 'Backtest',
    replay: 'Replay',
    downloadData: 'Télécharger les données',
    pairlistConfig: 'Config Pairlist',
    lockLayout: 'Verrouiller la disposition',
    resetLayout: 'Réinitialiser la disposition',
    logout: 'Déconnexion',
    exportPdf: 'Exporter en PDF',
    strategyDev: 'Dev Stratégie',
    journal: 'Journal',
    editPage: 'Éditer le dashboard',
    editModeHint: 'Mode édition — Déplacez, redimensionnez et masquez les widgets',
    editModeDone: 'Terminé',
    opacity: 'Opacité',
    bgAnimation: 'Animation',
    bgAnimationDesc:
      "Active ou désactive le fond animé avec dégradés sur le dashboard. Désactiver réduit l'utilisation GPU et améliore les performances sur les machines moins puissantes.",
    exportConfig: 'Exporter la config',
    importConfig: 'Importer une config',
    pageConfig: 'Config de la page',
    configDesc:
      "Sauvegardez et restaurez la disposition du dashboard et vos préférences d'affichage.",
    resetLayout: 'Réinitialiser la disposition',
    resetLayoutConfirm:
      'Êtes-vous sûr de vouloir réinitialiser la disposition du dashboard par défaut ? Vous perdrez tous vos ajustements de fenêtres, de colonnes, de placement, de taille, etc.',
    optimizeLayout: 'Optimiser la fenêtre',
    optimizeLayoutConfirm:
      'Tous les widgets visibles seront déplacés le plus en haut à gauche possible, en conservant leur taille actuelle. Les widgets masqués ne sont pas affectés.',
    newVersionAvailable: 'Nouvelle version disponible',
    includeAuth: "Inclure les tokens d'authentification",
    authPasswordRequired:
      'Les tokens donnent un contrôle total sur vos bots. Un mot de passe est requis pour chiffrer le fichier.',
    layoutOnlyDesc:
      "Disposition, thèmes et préférences d'affichage uniquement — aucune donnée sensible.",
    authIncludedDesc:
      'Inclut les tokens de connexion aux bots. Le fichier sera chiffré avec votre mot de passe.',
    encryptionPassword: 'Mot de passe de chiffrement',
    passwordMinChars: 'Minimum 8 caractères',
    export: 'Exporter',
    cancel: 'Annuler',
    importPreview: "Aperçu de l'import",
    exportDate: 'Exporté le',
    fileAge: 'Âge du fichier',
    daysUnit: 'jours',
    containsAuth: 'Authentification',
    authNotIncluded: 'Disposition uniquement',
    authEncrypted: 'Chiffré',
    authUnencrypted: 'Non chiffré (ancien format)',
    settingsCount: 'Paramètres',
    botsCount: 'Bots',
    integrityCheck: 'Intégrité',
    integrityValid: 'Valide',
    integrityFailed: 'Échouée',
    integrityNA: 'N/A',
    expiredWarning:
      "Ce fichier a plus de 7 jours. Les tokens d'authentification peuvent être compromis ou expirés.",
    integrityFailedDetail:
      "Le fichier a été modifié depuis l'export. Il a peut-être été falsifié. L'import est bloqué.",
    enterPassword: 'Entrez le mot de passe de chiffrement',
    wrongPassword: 'Mot de passe incorrect — veuillez réessayer.',
    integrityFailedImport:
      "Vérification d'intégrité échouée — le fichier a peut-être été falsifié.",
    passwordNeeded: 'Ce fichier est chiffré — un mot de passe est requis.',
    invalidFile: 'Fichier de configuration invalide ou corrompu.',
    importSuccess: 'Configuration restaurée',
    reloading: 'Rechargement de la page...',
    applyConfig: 'Appliquer la configuration',
    encryptionUnavailable:
      'Le chiffrement nécessite HTTPS. Utilisez une connexion sécurisée ou exportez sans les tokens.',
  },

  // Dashboard
  dashboard: {
    profitOverTime: 'Profit cumulé (combiné)',
    botComparison: 'Global · Comparateur de bots',
    openTrades: 'Bot · Trades ouverts',
    openTradesDesc:
      'Trades ouverts de tous les bots sélectionnés. Cliquez sur un trade pour accéder à la page du trade.',
    closedTrades: 'Bot · Trades fermés',
    closedTradesDesc:
      'Trades fermés de tous les bots sélectionnés. Cliquez sur un trade pour accéder à la page du trade.',
    profitBenchmark: 'Bot · Profits et benchmarks',
    cumulativeProfit: 'Profit cumulé',
    profitDistribution: 'Bot · Distribution des profits',
    tradesLog: 'Journal des trades',
    activityTimeline: "Global · Fil d'activité",
    marketOverview: 'Global · Pouls du marché',
    performanceHeatmap: 'Carte thermique des performances',
    riskOverview: 'Global · Aperçu des risques',
    stressTest: 'Global · Test de stress',
    logConsole: 'Système · Console de logs',
    rateBudget: 'Budget de taux',
    ratePulse: 'Pouls des requêtes',

    cacheHealth: 'Santé du cache',
    rateMonitor: 'Système · Budget API',
    requestTimeline: 'Système · Requêtes API',
    infraHealth: 'Système · Infrastructure',
    volumeComparator: 'Global · Comparateur de volume',
    periodBreakdown: 'Global · Ventilation par période',
    botProfitComparison: 'Bot · Profit par bot',
    botComparisonDesc:
      'Santé et performance de chaque bot connecté. Les cases à cocher choisissent les bots qui alimentent les widgets "Sélection".',
    profitBenchmarkDesc: 'Profit combiné des bots sélectionnés comparé aux benchmarks.',
    profitDistributionDesc:
      'Distribution des profits des trades fermés pour les bots sélectionnés.',
    activityTimelineDesc:
      "Fil chronologique des événements (trades, DCA, alertes) de tous les bots.",
    marketOverviewDesc:
      'Instantané du marché pour les paires tradées par les bots. Rafraîchi toutes les 30 s.',
    riskOverviewDesc: 'Exposition agrégée et indicateurs de risque de tous les bots.',
    stressTestDesc:
      'Simule un mouvement de marché (-50 % à +50 %) sur toutes les positions ouvertes, liquidations comprises.',
    logConsoleDesc:
      'Logs agrégés des bots (avertissements et erreurs). Rafraîchi toutes les 10 s.',
    rateMonitorDesc:
      "Budget API de l'exchange : cadence de requêtes, taux de cache, erreurs 429.",
    requestTimelineDesc:
      'Chronologie des requêtes API par bot : directes, en cache, erreurs, latence.',
    infraHealthDesc:
      'Santé des process bots : état, uptime, heartbeats, taille de la pairlist.',
    volumeComparatorDesc: "Volume tradé par les bots comparé au volume de l'exchange par période.",
    periodBreakdownDesc: 'Profit ventilé par jour, semaine ou mois sur tous les bots.',
    botProfitComparisonDesc:
      'Contribution au profit de chaque bot sur la période choisie, pour les bots sélectionnés.',
    opened: 'ouvert',
    closed: 'fermé',
  },
  widgetScope: {
    selection: 'Sélection',
    selectionTitle: 'Données des bots actuellement cochés dans le comparateur de bots',
    all: 'Tous les bots',
    allTitle: 'Données de tous les bots connectés, indépendamment de la sélection',
    fleet: 'Flotte',
    fleetTitle:
      'Agrégat côté serveur sur la flotte entière, y compris les bots non connectés dans ce navigateur',
    system: 'Système',
    systemTitle: 'Supervision infrastructure et API, pas des données de trading',
  },
  widgetState: {
    retry: 'Réessayer',
    fetchError: 'Échec du chargement des données',
  },
  botProfitComparison: {
    fleetTotal: 'Total flotte',
    bots: 'Bots',
    trades: 'Trades',
    tradeCount: '{n} trades sur la période',
    sortBy: 'Trier par',
    sortProfit: 'Profit',
    sortMagnitude: 'Ampleur',
    sortName: 'Nom',
    exportPNG: 'Exporter en image',
    noData: 'Aucun trade fermé pour les bots et la période sélectionnés',
  },
  volumeComparator: {
    exchangeVolume: 'Volume Exchange',
    botVolume: 'Volume Bot',
    tradeCount: 'Trades',
    profit: 'Profit',
    anomalies: 'Anomalies',
    volumeRatio: 'Ratio Vol',
    coverage: 'couverture pairs',
    correlation: 'Corrélation',
    noData:
      'Données OHLCV non disponibles. Lancez freqtrade download-data pour les pairs whitelist.',
    loading: 'Chargement des données de volume...',
    profitPerVol: 'Profit/Vol',
  },

  // Profit cumulé amélioré
  cumProfit: {
    title: 'Profit cumulé',
    tabProfit: 'Profit',
    tabProfitBalance: 'Profit + Solde',
    tabPerBot: 'Par bot',
    tabProportion: 'Proportion',
    profit: 'Profit',
    balance: 'Solde',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: 'Aucune donnée de trade disponible',
    statTotalProfit: 'Profit total',
    statPeak: 'Pic de profit',
    statDrawdown: 'Drawdown max',
    statRecovery: 'Récupération %',
    statBestBot: 'Meilleur bot',
    highWaterMark: 'High Water Mark',
  },

  // Distribution des profits améliorée
  profitDist: {
    tabHistogram: 'Histogramme',
    tabPerBot: 'Par bot',
    tabPerPair: 'Par paire',
    tabByDuration: 'Par durée',
    tradeCount: 'Nombre de trades',
    profitPct: 'Profit %',
    profitAbs: 'Profit ({currency})',
    avgProfit: 'Profit moyen',
    avgProfitPct: 'Profit moyen %',
    duration: 'Durée',
    trades: 'Trades',
    mean: 'Moyenne',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: 'Aucune donnée de trade disponible',
    statMean: 'Moyenne',
    statMedian: 'Médiane',
    statStdDev: 'Écart type',
    statSkewness: 'Asymétrie',
    statBest: 'Meilleur',
    statWorst: 'Pire',
    statWinRate: 'Taux victoire',
    statTrades: 'Trades',
    skewnessPositive: 'Asymétrie positive : plus de gros gains',
    skewnessNegative: 'Asymétrie négative : plus de grosses pertes',
    tabByLeverage: 'Par levier',
    leverage: 'Levier',
    filterAll: 'Tous',
    filterSpot: 'Spot uniquement',
    filterFutures: 'Futures uniquement',
    filterLong: 'Long uniquement',
    filterShort: 'Short uniquement',
  },

  // Profit dans le temps amélioré
  profitEnhanced: {
    combined: 'Combiné',
    projected: 'Projeté (incl. ouverts)',
    combinedMode: 'Combiné (tous les bots cumulés)',
    perBotMode: 'Par bot (lignes séparées)',
    stackedMode: 'Aire empilée (contribution)',
    absLabel: 'USDC',
    profitAbs: 'Profit (USDC)',
    profitPct: 'Profit (%)',
    periodReturn: 'Rendement période',
    bestDay: 'Meilleur jour',
    worstDay: 'Pire jour',
    avgDaily: 'Moy. journalière',
    trades: 'Trades',
    sharpe: 'Sharpe',
    maxDD: 'DD Max',
    winRate: 'Taux réussite',
    profitFactor: 'Facteur profit',
    exportCSV: 'Exporter les données du graphique en CSV',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: 'Aucune donnée de trade pour cette période',
  },

  // Graphique Profit & Benchmarks
  profitBenchmark: {
    tabCombined: 'Combiné',
    tabPerBot: 'Par bot',
    tabCumulative: 'Cumulatif',
    combined: 'Combiné',
    projected: 'Projeté (incl. ouverts)',
    highWaterMark: 'High Water Mark',
    normAbsolute: 'Absolu',
    normPctFromStart: '% depuis le début',
    normPctFromCapital: '% du capital',
    profitAbs: 'Profit',
    profitPct: 'Profit (%)',
    benchmarkPct: 'Benchmark (%)',
    periodReturn: 'Rendement période',
    vsBTC: 'vs BTC',
    sharpe: 'Sharpe',
    maxDD: 'DD Max',
    winRate: 'Taux réussite',
    benchmarks: 'Benchmarks',
    normalization: 'Normalisation',
    normExplain: 'Comment ça marche',
    normExplainDetail:
      'En mode "% depuis le début", votre profit et les benchmarks partent tous de 0% et montrent le changement en pourcentage. Cela permet de comparer directement : vos bots ont-ils surperformé le BTC ?',
    altProxy: 'proxy marché alt',
    solLabel: 'Solana',
    bnbLabel: 'BNB Chain',
    traditionalNote: 'Les benchmarks marchés traditionnels nécessitent une clé API',
    settings: 'Paramètres du graphique',
    exportCSV: 'Exporter en CSV',
    exportPNG: 'Exporter le graphique en PNG',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: 'Aucune donnée de trade pour cette période',
    currencySelector: "Devise d'affichage",
    currencyAuto: 'Auto',
    addBenchmark: 'Ajouter un benchmark',
    removeBenchmark: 'Retirer le benchmark {coin}',
    customCoinGecko: 'Personnalisé (ID CoinGecko)',
    customPlaceholder: 'ex. cardano',
    customNotFound: 'ID introuvable sur CoinGecko',
    add: 'Ajouter',
    outperforming: 'Surperformance',
    underperforming: 'Sous-performance',
    by: 'de',
    descCombined:
      'Ce graphique montre le profit combiné de tous vos bots sélectionnés (somme des profits des trades fermés sur tous les exchanges et toutes les devises, convertis si nécessaire)',
    descPerBot: 'Ce graphique montre le profit individuel de chaque bot',
    descCumulative:
      'Ce graphique montre le total cumulé de tous les profits des trades fermés (chaque profit de trade est ajouté chronologiquement pour former la courbe de capital)',
    descOverPeriod: 'sur les derniers {period}',
    descNormPctStart: 'exprimé en pourcentage de variation depuis le début de la période',
    descNormAbsolute: 'en {currency}',
    descNormPctCapital: 'en pourcentage du capital initial',
    descBenchmarks: 'Comparaison benchmark : {list}',
    descBenchmarkHint:
      "Si votre ligne de profit est AU-DESSUS d'un benchmark, vous le surperformez.",
  },

  // Bot comparison table
  botComparison: {
    botName: 'Nom du bot',
    all: 'Tous',
    showInDashboard: 'Afficher ce bot dans le tableau de bord',
    toggleAll: 'Basculer tous les bots',
    selectAllBots: 'Cliquez pour sélectionner tous les bots',
    selectDryBots: 'Cliquez pour sélectionner les bots dry run',
    selectLiveBots: 'Cliquez pour sélectionner les bots live',
    trades: 'Trades',
    openProfit: 'Profit ouvert',
    totalProfit: 'Profit total (ouvert et réalisé)',
    closedProfit: 'Profit fermé',
    currentProfit: 'Profit courant',
    maxDrawdown: 'Max Drawdown',
    withdrawnLabel: 'dont {amount} retirés',
    netAfterWithdrawals: '{amount} net après retraits',
    balance: 'Solde',
    winLoss: 'G/P',
    lastTrade: 'Dernier trade',
    lastTradeOthersToday: 'autres aujourd\'hui',
    lastTradeOthersTodayTooltip:
      '{n} autre trade clôturé aujourd\'hui | {n} autres trades clôturés aujourd\'hui',
    offline: 'Hors ligne',
    offlineSince: 'depuis {duration}',
    dry: 'Dry',
    live: 'Live',
    exchange: 'Exchange',
    selectByExchange: 'Cliquez pour sélectionner les bots {exchange}',
    stakeAmount: 'Mise',
    port: 'Port',
    strategy: 'Stratégie',
    pairCount: 'Paires',
    stakeCurrencyLabel: 'Devise',
    selectByCurrency: 'Cliquez pour sélectionner les bots {currency}',
    weeklyProfit: 'Profit hebdo',
    yearlyProfit: 'Profit annuel',
    monthlyProfit: 'Profit mensuel',
    availableCapital: 'Capital initial (config)',
    tradableBalanceRatio: 'Ratio tradable (config)',
    availableFunds: 'Capital disponible',
    fundsGain: 'Gains réalisés',
    fundsWithdraw: 'Retraits',
    fundsTotal: 'Capital disponible',
    hostBotBadge: 'hôte',
    hostBotTooltip: 'Ce bot héberge FreqUI',
    addColumn: 'Ajouter une colonne',
    hideColumn: 'Cliquer pour masquer cette colonne',
    botOfflineDesc: 'Ce bot est actuellement hors ligne. Aucune donnée en direct disponible.',
    lastSeenOnline: 'Dernière connexion il y a {duration}',
    botLoading: 'Ce bot est en cours de démarrage...',
    botLoadingDesc: 'Veuillez patienter pour afficher ses informations.',
    resetColumns: 'Restaurer les colonnes FreqUI à leur état initial',
    columnSettings: 'Colonnes visibles',
    correlation: 'Corrélation détectée',
    correlationDesc: 'Plusieurs bots tradent la même paire simultanément',
    renameBot: 'Renommer le bot',
    dragToReorder: 'Glisser pour réordonner',
    statusLabel: 'Statut',
    onlineSince: 'En ligne depuis {duration}',
    // Sort & Filter
    sort: 'Trier',
    sortBy: 'Trier par',
    ascending: 'Croissant',
    descending: 'Décroissant',
    filters: 'Filtres',
    visibility: 'Visibilité',
    showOnlineSince: 'Afficher la date de mise en ligne',
    botTags: 'Tags du bot',
    byStatus: 'Par statut',
    byExchange: 'Par exchange',
    byCurrency: 'Par devise',
    botsHidden: '{count} bot masqué | {count} bots masqués',
    allBotsVisible: 'Tous les bots sont visibles',
    botsHiddenByFilters:
      '{count} bot masqué par les filtres | {count} bots masqués par les filtres',
    showAllBots: 'Cliquez pour afficher tous les bots',
    sortCustom: 'Ordre personnalisé',
    sortByName: 'Nom du bot',
    sortByStartDate: 'Date de démarrage',
    sortByProfit: 'Profit fermé',
    sortByCurrentProfit: 'Profit courant',
    sortByBalance: 'Solde',
    sortByCurrency: 'Devise',
    sortByExchange: 'Exchange',
    sortByStatus: 'Statut',
    sortByStrategy: 'Stratégie',
    sortByWeekly: 'Profit hebdo',
    sortByMonthly: 'Profit mensuel',
    sortByDrawdown: 'Drawdown',
    sortByWinrate: 'Winrate',
    sortByTradeCount: 'Nombre de trades',
    sortByOpenPositions: 'Positions ouvertes',
    tagStatus: 'Statut (Dry/Live/Hors ligne)',
    tagExchange: 'Exchange',
    tagCurrency: 'Devise de mise',
    tagPort: 'Port',
    tagTradingMode: 'Mode de trading (Futures/Spot)',
    byTradingMode: 'Par mode de trading',
    filtersTitle: 'Filtres',
    resetSort: 'Réinitialiser le tri',
    resetFilters: 'Réinitialiser les filtres',
    // Alerts
    alerts: 'Alertes',
    alertEnabled: 'Alerte activée',
    lossThreshold: 'Seuil de perte',
    positionAtRisk: 'Position à risque : perte non réalisée dépasse le seuil',
    // Alert system v2
    alertsReset: 'Réinitialiser',
    alertCategoryPosition: 'Position',
    alertCategoryLog: 'Logs',
    alertCategoryActivity: 'Activité',
    alertCategorySystem: 'Système',
    alertPositionLoss: 'Perte non réalisée',
    alertPositionLossDesc: 'La perte dépasse le seuil défini',
    alertPositionStuck: 'Position bloquée',
    alertPositionStuckDesc: 'Maintenue plus de X fois la durée moyenne',
    alertNearLiquidation: 'Proche liquidation',
    alertNearLiquidationDesc: 'À moins de X% du prix de liquidation (futures)',
    alertLogErrors: 'Erreurs dans les logs',
    alertLogErrorsDesc: 'Erreurs détectées dans les logs récents',
    alertOrderFailed: "Échec d'ordre",
    alertOrderFailedDesc: "Impossible d'ouvrir ou fermer une position",
    alertInsufficientFunds: 'Fonds insuffisants',
    alertInsufficientFundsDesc: 'Pas assez de fonds pour ouvrir une position',
    alertExchangeError: 'Erreur exchange',
    alertExchangeErrorDesc: "Problèmes de connectivité avec l'exchange",
    alertWalletMismatch: 'Désync wallet',
    alertWalletMismatchDesc: 'Décalage de balance du wallet détecté',
    alertNoTradeActivity: 'Pas de trade',
    alertNoTradeActivityDesc: 'Aucun trade ouvert depuis X heures',
    alertBotOffline: 'Bot hors ligne',
    alertBotOfflineDesc: 'Le bot est hors ligne',
    alertHighDrawdown: 'Drawdown élevé',
    alertHighDrawdownDesc: 'Le drawdown actuel dépasse le seuil',
    alertCapacityFull: 'Capacité pleine',
    alertCapacityFullDesc: 'Tous les slots de trade sont occupés',
    alertAllFundsExposed: 'Totalité des fonds exposés',
    alertAllFundsExposedDesc:
      'La quasi-totalité du capital est bloquée dans les positions ouvertes',
    alertLiquidationBeforeStoploss: 'Liquidation avant stoploss',
    alertLiquidationBeforeStoplossDesc:
      'Le prix de liquidation est plus proche que le stoploss (futures)',
    alertIncludeLeverage: 'Inclure le levier',
    alertPerBot: 'Par bot',
    alertAllConfigured: '{count} alerte configurée | {count} alertes configurées',
    alertToggleAllOn: 'Tout ON',
    alertToggleAllOff: 'Tout OFF',
    alertGlobalApply: "Les réglages s'appliquent à tous les bots. Désactivez par bot ci-dessous.",
    alertActiveCount: '{count} alerte active | {count} alertes actives',
    alertViewLogs: 'Voir les logs',
    // Bot Groups
    botGroups: 'Groupes de bots',
    createGroup: 'Créer un groupe',
    deleteGroup: 'Supprimer le groupe',
    ungrouped: 'Non groupé',
    groupName: 'Nom du groupe',
    groupIcon: 'Icône',
    addToGroup: 'Ajouter au groupe',
    removeFromGroup: 'Retirer du groupe',
    createGroupInline: 'Créer un groupe',
    changeIcon: "Changer l'icône",
    clearIcon: "Retirer l'icône",
    resetIcon: "Réinitialiser l'icône",
    searchIcon: 'Rechercher un emoji…',
    recentIcons: 'Récemment utilisés',
    noIconResults: 'Aucun emoji ne correspond à votre recherche',
    editGroup: 'Modifier le groupe',
    moveToFolder: 'Déplacer dans un dossier',
    currentFolder: 'actuel',
    noGroupsAvailable: "Aucun dossier disponible. Créez-en un d'abord.",
    alertsTitle: 'Configuration des alertes',
    groupsTitle: 'Groupes de bots',
    noAlerts: 'Aucune alerte',
    positionsAtRisk: '{count} position à risque | {count} positions à risque',
    ungroupedBots: 'Bots sans groupe',
    // Custom Tags
    customTags: 'Tags personnalisés',
    addTag: 'Ajouter un tag',
    createTag: 'Créer un tag',
    tagName: 'Nom du tag',
    tagColor: 'Couleur',
    deleteTag: 'Supprimer le tag',
    editTag: 'Modifier le tag',
    filterByTag: 'Cliquer pour sélectionner les bots avec ce tag',
    byCustomTag: 'Par tag personnalisé',
    keyboardShortcuts:
      'Raccourcis clavier : Échap=fermer, 1-9=basculer bot, F=filtrer, S=trier, Ctrl+A=tout sélectionner',
    botActions: 'Actions du bot',
    actionStart: 'Démarrer',
    actionPause: 'Pause (arrêter les achats)',
    actionStop: 'Arrêter',
    actionReload: 'Recharger la config',
    actionForceExitAll: 'Couper toutes les positions',
    viewLogs: 'Voir les logs',
    viewTrades: 'Voir les trades',
    viewJournal: 'Voir le journal de trades',
    analyzeStrategy: 'Analyser la stratégie',
    dryRunReplay: 'Simuler un dry-run (replay)',
    dryRunReplayView: 'Voir le dry-run replay en cours',
    dryRunReplayDone:
      'Un dry-run replay a déjà été simulé. Repars d’une DB dry-run vierge pour relancer.',
    editConfig: 'Modifier la configuration',
    confirmAction: "Confirmer l'action",
    confirmActionMsg: 'Êtes-vous sûr de vouloir {action} sur {bot} ?',
    replay: {
      title: 'Dry-run replay — {bot}',
      intro:
        'Rejoue la vraie boucle live du bot sur l’historique, puis injecte les trades simulés dans la DB dry-run de ce bot — comme s’il tournait depuis la date choisie.',
      strategy: 'Stratégie',
      wallet: 'Portefeuille simulé',
      pairs: 'Paires (filtre actuel)',
      loading: 'Chargement des paires actuelles…',
      pairsWarning:
        'Le replay utilise les {n} paires actuellement sélectionnées par le filtre. Les pairlists dynamiques ne sont pas rejouées historiquement → biais de sélection sur ces paires précises.',
      noPairs:
        'Impossible de déterminer les paires du bot (whitelist vide, aucun trade, aucune whitelist dans les logs). Le bot est-il initialisé ? Réessaie quand sa pairlist est prête.',
      pairsSource_trades:
        'Whitelist live indisponible — utilisation des paires réellement tradées par ce bot.',
      pairsSource_logs:
        'Whitelist live indisponible — utilisation de la dernière whitelist loggée par le bot.',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      fundingHint: 'Le funding n’est fidèle que si tu as les données de funding sur la période.',
      preventDry: 'Dry-run uniquement — aucun ordre réel.',
      preventIsolated: 'Tourne dans un processus isolé — le bot continue de trader.',
      preventOnce: 'Action unique : pour relancer, repars d’une DB dry-run vierge.',
      alreadyTitle: 'Déjà simulé',
      alreadyMsg:
        'Un dry-run replay a déjà été simulé sur ce bot ({timerange}). Pour en relancer un, repars d’une DB dry-run vierge.',
      resultTitle: 'Résultat (simulé)',
      closed: 'Trades clôturés',
      winRate: 'Taux de réussite',
      pnl: 'P&L total',
      doneReload: 'Terminé — bot rechargé avec l’historique simulé.',
      run: 'Lancer le replay',
      close: 'Fermer',
      resolution: 'Résolution (sous-pas)',
      resolutionHint:
        'Plus le sous-pas est petit, plus c’est long mais plus c’est fidèle (fills intra-candle plus fins). Le 1m nécessite des données 1m téléchargées.',
      today: 'Aujourd’hui',
      stop: 'Arrêter',
      elapsed: 'Écoulé',
      eta: 'Restant',
      runningTitle: 'Dry-run replay en cours',
      seededTitle: 'Semé par un dry-run replay ({timerange}) — cliquer pour voir / re-semer',
      seededTitleShort: 'Semé par un dry-run replay — cliquer pour voir / re-semer',
      badge: 'Dry-run replay',
      pausedBadge: 'Replay en pause',
      coverageLoading: 'Vérification des données locales…',
      coverageNone:
        'Aucune donnée {tf} trouvée localement pour ces paires — pas de fills à cette résolution.',
      coverageEarliest:
        'Première donnée {tf} : {date} ({n}/{total} paires). Un dry-run replay avant cette date ne sera pas fidèle à cette résolution.',
      startBeforeData:
        'Pas d’historique avant {date} ; le replay ne sera fidèle qu’à partir de cette date.',
      endFuture:
        'Date de fin dans le futur — le replay s’arrête aux dernières données dispo (téléchargeables jusqu’à récemment sur Hyperliquid).',
      closeContinues:
        'Vous pouvez fermer cette fenêtre — le replay continue en arrière-plan. Un indicateur sur le bot dans « Comparaison des bots » montre sa progression.',
      restore: 'Restaurer la DB',
      restoreHint:
        'Restaure la sauvegarde de la base prise juste avant ce replay (annule un seed planté ou non voulu). Le bot redémarre.',
      restoreConfirm:
        'Restaurer la base de ce bot depuis la sauvegarde pré-replay ? La base actuelle (semée) sera écrasée et le bot rechargé.',
      tradeBadge: 'replay',
      resetDb: 'Réinitialiser la base d’abord',
      resetDbHint:
        'Efface les trades dry-run existants avant le seed. Décoché : les trades existants sont conservés et le replay s’arrête au premier trade réel.',
      detailPeriod: 'Période',
      detailDuration: 'Durée',
      detailPairs: 'Paires',
      detailReplayResult: 'Résultat du replay',
      detailCurrent: 'Actuel (replay + dry-run depuis)',
      detailOutside: 'Trades depuis le replay',
      queueTitle: 'Coordinateur : {cap} créneaux libres ({cores} cœurs, {hopt} pris par hyperopt)',
      prioritize: 'Prioriser',
      stateQueued: 'En file — en attente d’un cœur libre',
      statePaused: 'En pause — cœurs occupés (hyperopt ou replays plus prioritaires)',
      tradeBadgeHint: 'Trade simulé issu d’un dry-run replay (pas une activité live).',
    },
  },

  maxDrawdownCard: {
    title: 'Drawdown maximum',
    none: 'Aucun drawdown',
    noneDesc: 'Aucune baisse pic-à-creux enregistrée.',
    realized: 'Réalisé (fermé)',
    inclOpen: 'Incl. positions ouvertes',
    realizedShort: 'Réal.',
    openShort: 'Ouv.',
    realizedCurve: 'Réalisé — trades fermés',
    openCurve: 'Incluant les positions ouvertes à leur plus bas',
    openCurveHint: 'La queue projette les positions ouvertes jusqu’au plus bas atteint.',
    notEnoughData: 'Pas assez de trades fermés pour tracer la courbe.',
    peak: 'Plus haut',
    trough: 'Plus bas',
    openPositions: 'Positions ouvertes (actuel → plus bas)',
    low: 'plus bas',
    responsibleTrades: 'Trades responsables',
    tradesInWindow: 'Trades pendant le drawdown',
    group: 'Groupe',
    summary: 'Résumé',
  },

  configEditor: {
    title: 'Modifier la configuration',
    loading: 'Chargement de la configuration…',
    unsupportedTitle: 'Backend non compatible',
    unsupportedMsg:
      "Ce bot n'expose pas les endpoints d'édition de configuration. Mets à jour le backend freqtrade du bot pour activer cette fonctionnalité.",
    readOnlyFile:
      "Le fichier de configuration de ce bot n'est pas dans un dossier modifiable — édition désactivée.",
    loadIncomplete:
      "Impossible de lire le fichier de configuration de ce bot — édition désactivée pour éviter de l'écraser. Ferme et rouvre le popup.",
    help: 'Voir la documentation freqtrade',
    lockedHint: 'Verrouillé : à modifier manuellement dans le fichier (risqué à chaud).',
    restartHint: 'Nécessite un redémarrage du bot, pas seulement un rechargement.',
    restart: 'redémarrage',
    revert: 'Revenir à la valeur héritée',
    overrideFromConfig: 'Surcharger dans la config',
    unlimited: 'illimité',
    none: '(aucun)',
    choose: 'Choisir…',
    source: {
      own: 'défini ici',
      inherited: 'hérité',
      strategy: 'stratégie',
      default: 'défaut',
    },
    sections: {
      capital: 'Capital & Sizing',
      trading: 'Trading',
      risk: 'Risque & Sorties',
      orders: 'Ordres & Timeouts',
      pricing: 'Pricing',
      pairlists: 'Pairlists',
      notifications: 'Notifications',
      system: 'Système (verrouillé)',
      add: 'Ajouter un paramètre',
      raw: 'JSON brut',
    },
    fields: {
      max_open_trades: 'Trades simultanés max',
      stake_amount: 'Mise par trade',
      tradable_balance_ratio: 'Ratio de capital tradable',
      capital_withdrawal: 'Capital retiré',
      available_capital: 'Capital initial de référence',
      last_stake_amount_min_ratio: 'Ratio min. dernière mise',
      amount_reserve_percent: 'Réserve de montant (%)',
      amend_last_stake_amount: 'Ajuster la dernière mise',
      position_adjustment_enable: "Activer l'ajustement de position (DCA)",
      max_entry_position_adjustment: "Ajustements d'entrée max",
      bot_name: 'Nom du bot',
      strategy: 'Stratégie',
      process_throttle_secs: 'Throttle de la boucle (s)',
      process_only_new_candles: 'Traiter uniquement les nouvelles bougies',
      force_entry_enable: "Autoriser l'entrée forcée",
      cancel_open_orders_on_exit: "Annuler les ordres ouverts à l'arrêt",
      initial_state: 'État initial',
      fiat_display_currency: "Devise fiat d'affichage",
      stoploss: 'Stop-loss',
      minimal_roi: 'ROI minimal',
      trailing_stop: 'Trailing stop',
      trailing_stop_positive: 'Trailing stop positif',
      trailing_stop_positive_offset: 'Offset trailing stop positif',
      trailing_only_offset_is_reached: "Trailing seulement après l'offset",
      use_exit_signal: 'Utiliser le signal de sortie',
      exit_profit_only: 'Sortir uniquement en profit',
      ignore_roi_if_entry_signal: "Ignorer le ROI si signal d'entrée",
      order_types_entry: "Type d'ordre — entrée",
      order_types_exit: "Type d'ordre — sortie",
      order_types_stoploss: "Type d'ordre — stop-loss",
      stoploss_on_exchange: "Stop-loss sur l'exchange",
      stoploss_price_type: 'Type de prix du stop-loss',
      tif_entry: 'Time-in-force — entrée',
      tif_exit: 'Time-in-force — sortie',
      unfilledtimeout_entry: 'Timeout entrée non remplie',
      unfilledtimeout_exit: 'Timeout sortie non remplie',
      unfilledtimeout_unit: 'Unité de timeout',
      entry_price_side: 'Côté du prix — entrée',
      entry_price_last_balance: 'Balance dernier prix — entrée',
      entry_use_order_book: "Utiliser le carnet d'ordres — entrée",
      entry_order_book_top: 'Profondeur carnet — entrée',
      exit_price_side: 'Côté du prix — sortie',
      exit_price_last_balance: 'Balance dernier prix — sortie',
      exit_use_order_book: "Utiliser le carnet d'ordres — sortie",
      exit_order_book_top: 'Profondeur carnet — sortie',
      pairlists: 'Handlers de pairlist',
      pair_blacklist: 'Liste noire de paires',
      pair_whitelist: 'Liste blanche de paires',
      telegram_enabled: 'Telegram activé',
      notify_status: 'Notif. statut',
      notify_entry: 'Notif. entrée',
      notify_exit: 'Notif. sortie',
      notify_protection: 'Notif. protection',
      db_url: 'URL de la base de données',
      trading_mode: 'Mode de trading',
      margin_mode: 'Mode de marge',
      stake_currency: 'Devise de mise',
      dry_run: 'Dry-run',
      dry_run_wallet: 'Wallet dry-run',
      exchange_name: 'Exchange',
      api_listen_port: "Port de l'API",
    },
    tagPlaceholder: 'Une paire par ligne, ex. BTC/USDC:USDC',
    addRoi: 'Ajouter un palier ROI',
    addIntro: 'Ajoute un paramètre connu de freqtrade absent de ta configuration actuelle.',
    addedFields: 'Paramètres ajoutés',
    searchParam: 'Rechercher un paramètre…',
    removeParam: 'Supprimer',
    rawIntro: 'Édition directe du JSON écrit dans {file}. Validé en temps réel.',
    schemaWarnings: '{n} avertissement(s) de schéma',
    nChanges: '{n} changement(s)',
    noChanges: 'Aucun changement',
    restartNeeded: 'redémarrage requis',
    cancel: 'Annuler',
    save: 'Enregistrer',
    savedTitle: 'Configuration enregistrée',
    savedMsg:
      'Les modifications ont été écrites dans le fichier du bot (une sauvegarde .bak a été créée).',
    savedRestartMsg:
      'Un des changements nécessite un redémarrage complet : le rechargement à chaud ne suffira pas.',
    savedChoose: 'Que souhaites-tu faire maintenant ?',
    reloadNow: 'Recharger la config',
    stopNow: 'Arrêter le bot',
    later: 'Plus tard',
    savedTo: 'Configuration enregistrée dans {file}',
    saveFailed: "Échec de l'enregistrement : {detail}",
    reloadTriggered: 'Rechargement de la configuration demandé',
    stopTriggered: 'Arrêt du bot demandé',
    errRequired: 'Champ requis',
    errNumber: 'Doit être un nombre',
    errInteger: 'Doit être un entier',
    errMin: 'Minimum {min}',
    errMax: 'Maximum {max}',
    errPattern: 'Format invalide',
    errBothUnlimited: 'max_open_trades et stake_amount ne peuvent pas être tous deux illimités',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    removeHandler: 'Supprimer le handler',
    addParam: 'Ajouter un paramètre',
    addHandler: 'Ajouter un handler',
    noPairlist: 'Aucun handler de pairlist défini.',
  },

  // Alert Detail Card
  alertDetail: {
    stakeAtRisk: 'Mise à risque',
    ifClosedNow: 'Si fermé maintenant',
    heldFor: 'Détenu depuis {duration} (moy : {avg})',
    lastError: 'Dernière erreur',
    viewLogs: 'Voir les logs',
    viewTrades: 'Voir les trades',
    away: 'de distance',
    currentPrice: 'Prix actuel',
    liqPrice: 'Prix de liq.',
    locked: 'Bloqué',
    free: 'Libre',
    lastSeen: 'Dernière connexion',
    offlineFor: 'Hors ligne depuis',
    peakValue: 'Valeur maximale',
    currentValue: 'Valeur actuelle',
  },

  // Open Profit Card
  openProfitCard: {
    unrealizedPnl: 'PnL non réalisé',
    onCapitalAtRisk: 'sur capital engagé',
    positions: 'POSITIONS',
    positionDetails: 'Détails des positions',
    noOpenTrades: 'Aucun trade ouvert',
    bestPosition: 'Meilleure position',
    worstPosition: 'Pire position',
    riskAnalysis: 'Analyse de risque',
    highestLoss: 'Plus grosse perte',
    highestGain: 'Plus gros gain',
    avgPositionProfit: 'Profit moyen / position',
    weightedAvgProfit: 'Profit moy. pondéré',
    totalStakeLocked: 'Mise totale bloquée',
    mostLoss: 'Plus de perte',
    mostGain: 'Plus de gain',
    durationContext: 'Contexte de durée',
    avgOpenDuration: 'Durée moy. ouverte',
    avgClosedDuration: 'Durée moy. fermée',
    exceedAvg: 'dépassent 2x la moy.',
    historicalRange: 'Plage historique',
    median: 'Médiane',
  },

  // Closed Profit Card
  closedProfitCard: {
    realizedPerformance: 'Performance réalisée',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: 'Aucune donnée de profit disponible',
    netAfterWithdrawals: 'Net après retraits',
    winRateStats: 'Taux de gain & Stats',
    totalTrades: 'Total trades',
    avgProfitTrade: 'Moy / trade',
    performanceMetrics: 'Métriques de performance',
    timeAnalysis: 'Analyse temporelle',
    tradingSpan: 'Période de trading',
    avgTradesPerWeek: 'Moy trades / semaine',
    avgTradesPerMonth: 'Moy trades / mois',
    avgProfitWeek: 'Profit moy / semaine',
    avgProfitMonth: 'Profit moy / mois',
    bestPair: 'Meilleure paire',
    withdrawalSummary: 'Résumé des retraits',
    totalWithdrawn: 'Total retiré',
    netProfitAfter: 'Profit net après',
    effectiveRoi: 'ROI effectif',
  },

  // Win/Loss Card
  winLossCard: {
    title: 'Analyse Gains/Pertes',
    winrate: 'TAUX DE GAIN',
    wins: 'gagnés',
    losses: 'perdus',
    totalTrades: 'trades au total',
    analysis: 'Analyse',
    currentStreak: 'Série en cours',
    avgWinLossRatio: 'Ratio moy. gain/perte',
    avgProfitPerTrade: 'Profit moy / trade',
    profitFactor: 'Facteur de profit',
  },

  // Balance Card
  balanceCard: {
    title: 'Solde & Capital',
    startingCapital: 'Capital initial',
    start: 'Début',
    current: 'Actuel',
    capitalAllocation: 'Allocation du capital',
    inOpenTrades: 'En trades ouverts',
    freeCapital: 'Capital libre',
    inTrades: 'En trades',
    free: 'Libre',
    openPositions: 'Positions ouvertes',
    withdrawals: 'Retraits',
    totalWithdrawn: 'Total retiré',
    totalDeposited: 'Total déposé',
    currentBalance: 'Solde actuel',
    summary: 'Résumé',
    totalProfit: 'Profit total (tout)',
    noWithdrawals: 'Aucun retrait',
  },

  // Period Profit Card
  periodProfitCard: {
    title: 'Analyse de profit périodique',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: "Pas assez de données pour l'analyse périodique",
    weeklyAvg: 'Moyenne hebdomadaire',
    monthlyAvg: 'Moyenne mensuelle',
    week: 'semaine',
    month: 'mois',
    dailyBreakdown: 'Détail journalier',
    dailyAvg: 'Moyenne journalière',
    annualizedReturn: 'Rendement annualisé',
    projections: 'Projections',
    projectionsDisclaimer: 'Au taux moyen actuel (non garanti)',
    months: 'mois',
    year: 'an',
    tradingPeriod: 'Période de trading',
    days: 'jours',
    totalRealized: 'Total réalisé',
    belowAverage: 'Sous la moy.',
    belowAverageWarning:
      'La performance récente pourrait être inférieure à la moyenne historique. Le CAGR suggère des rendements en décélération.',
    currentMonth: 'Mois en cours',
    currentYear: 'Année en cours',
    actual: 'Réel',
    projection: 'Projection',
    target: 'Objectif',
    today: "Aujourd'hui",
    onTrack: 'En bonne voie',
    behind: 'En retard',
    ahead: 'En avance',
    elapsed: 'écoulé',
    ofTarget: "de l'objectif",
  },

  // Trades Info Card
  tradesInfoCard: {
    positionOverview: "Vue d'ensemble",
    slots: 'SLOTS',
    allocated: 'alloué',
    currentPositions: 'Positions ouvertes',
    inDrawdown: 'en drawdown',
    noOpenPositions: 'Aucune position ouverte',
    durationAnalysis: 'Analyse de durée',
    avgClosedDuration: 'Durée moy. fermés',
    longestOpen: 'Plus longue ouverte',
    anomalyScore: "Score d'anomalie",
    stuck: 'Position potentiellement bloquée',
    avgDurationLine: 'Durée moyenne des trades fermés',
    durationTooltip: 'Maintenue {ratio}x plus longtemps que la moyenne',
    capitalExposure: 'Exposition du capital',
    totalAllocated: 'Total alloué',
    avgStake: 'Mise moy. / position',
    largestPosition: 'Plus grosse position',
    winningPositions: 'Positions gagnantes',
    losingPositions: 'Positions perdantes',
    winning: 'Gagnant',
    losing: 'Perdant',
    free: 'Libre',
    tradingRhythm: 'Rythme de trading',
    perDay: 'Trades / jour',
    perWeek: 'Trades / semaine',
    avgTimeBetween: 'Temps moy. entre trades',
    sinceLastTrade: 'Depuis dernier trade',
    unusuallyQuiet: 'Anormalement calme',
    winRate: 'Taux de gain',
    wins: 'gagnés',
    losses: 'perdus',
    total: 'total',
  },

  exchangeCard: {
    type: 'Type',
    founded: 'Fondé',
    maxLeverage: 'Levier max',
    token: 'Token',
    makerFee: 'Frais Maker',
    takerFee: 'Frais Taker',
    fees: 'Frais',
    headquarters: 'Siège',
    kyc: 'KYC',
    hq: 'Siège',
    tradingTypes: 'Types de trading',
    freqtradeSupport: 'Support Freqtrade',
    exchangeInfoUnavailable: "Informations de l'exchange indisponibles",
    filterByMode: 'Filtrer les bots par {mode}',
  },

  currencyCard: {
    type: 'Type',
    peg: 'Parité',
    peggedTo: 'Indexé sur {peg}',
    issuer: 'Émetteur',
    backing: 'Garantie',
    chain: 'Blockchain',
    risks: 'Risques',
    botImpact: 'Impact sur le bot',
    currencyInfoUnavailable: 'Informations de la devise indisponibles',
    filterByCurrency: 'Filtrer les bots par {currency}',
  },

  summaryCard: {
    openTitle: 'Profit ouvert — Tous les bots',
    closedTitle: 'Profit fermé — Tous les bots',
    botRanking: 'Classement des bots',
    capitalAtRisk: 'Capital à risque',
    performanceComparison: 'Comparaison des performances',
    bestBot: 'Meilleure performance',
    worstBot: 'Pire performance',
    avgRoi: 'ROI moyen',
    totalWithdrawals: 'Total retiré',
    winrateComparison: 'Comparaison des taux de réussite',
    ofTotal: 'du total',
  },

  summaryWinLoss: {
    title: 'G/P — Tous les bots',
    overallWinrate: 'Taux de réussite global',
    totalTrades: 'Total des trades fermés',
    avgWinrate: 'Taux de réussite moyen',
    bestPerformer: 'Meilleur taux de réussite',
    worstPerformer: 'Plus bas taux de réussite',
    outOfTrades: 'sur {count} trades',
  },

  summaryTrades: {
    title: 'Toutes les positions ouvertes',
    positions: 'positions',
    capacity: 'Capacité',
    perBot: 'Par bot',
    capitalExposure: 'Exposition du capital',
    multiCurrency: 'Multi-devises',
    perCurrency: 'Par devise',
    allCurrencies: 'Toutes les devises',
    winrateComparison: 'Comparaison des taux de réussite',
    balanceTitle: 'Solde total — Tous les bots',
    totalPerCurrency: 'Total par devise',
    ratesSource: 'Taux : CoinGecko',
    ratesUpdated: 'Mis à jour il y a {duration}',
    ratesUnavailable: 'Taux indisponibles',
    approximateConversion: 'Conversion approximative',
    convertedTotal: 'Total converti',
    conversionRate: 'Taux',
  },

  // Profit metrics
  profit: {
    profitsFor: 'Profits pour',
    all: 'Tous',
    long: 'Long',
    short: 'Short',
    trades: 'Trades',
    metric: 'Métrique',
    value: 'Valeur',
    roiClosed: 'ROI trades fermés',
    roiAll: 'ROI tous les trades',
    totalTradeCount: 'Nombre total de trades',
    botStarted: 'Bot démarré',
    firstTradeOpened: 'Premier trade ouvert',
    latestTradeOpened: 'Dernier trade ouvert',
    winLoss: 'Gains / Pertes',
    winrate: 'Taux de réussite',
    expectancy: 'Espérance (ratio)',
    cagr: 'CAGR',
    calmar: 'Calmar',
    sharpe: 'Sharpe',
    sortino: 'Sortino',
    sqn: 'SQN',
    pvalue: 'P-Value',
    avgDuration: 'Durée moyenne',
    bestPerforming: 'Meilleure performance',
    tradingVolume: 'Volume de trading',
    profitFactor: 'Facteur de profit',
    withdrawn: 'Retiré',
    netProfit: 'Profit net (après retraits)',
    maxDrawdown: 'Drawdown max',
    currentDrawdown: 'Drawdown actuel',
  },

  // Balance
  balance: {
    title: 'Solde du bot / Solde du compte',
    available: 'Disponible',
    total: 'Total',
    increaseOverCapital: 'Augmentation par rapport au capital initial de',
    currency: 'Devise',
    in: 'en',
    showingAccount: 'Solde du compte affiché',
    showingBot: 'Solde du bot affiché',
    hideSmall: 'Masquer les petits soldes',
    showAll: 'Afficher tous les soldes',
  },

  // Trade list
  tradeList: {
    id: 'ID',
    pair: 'Paire',
    amount: 'Quantité',
    stakeAmount: 'Mise',
    totalStakeAmount: 'Mise totale',
    openRate: "Prix d'entrée",
    currentRate: 'Prix actuel',
    closeRate: 'Prix de sortie',
    currentProfit: 'Profit actuel %',
    profit: 'Profit %',
    openDate: "Date d'ouverture",
    closeDate: 'Date de fermeture',
    closeReason: 'Raison de fermeture',
    bot: 'Bot',
    filter: 'Filtrer',
    noTrades: 'Aucun trade à afficher.',
    short: 'Short',
    long: 'Long',
    exitTrade: 'Fermer le trade',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    confirmExit:
      'Voulez-vous vraiment fermer le trade {id} (Paire {pair}) avec un ordre {orderType} ?',
    confirmDelete: 'Voulez-vous vraiment supprimer le trade {id} (Paire {pair}) ?',
    cancelOpenOrder: "Annuler l'ordre ouvert pour le trade {id} (Paire {pair}) ?",
    currentlyNoOpen: 'Aucun trade ouvert actuellement.',
    noClosedTrades: 'Aucun trade fermé pour le moment.',
  },

  // Listes de trades améliorées
  enhancedTrades: {
    trades: 'trades',
    filterPlaceholder: 'Filtrer par paire, bot, tag...',
    columnSettings: 'Paramètres des colonnes',
    colBotState: 'État',
    colBot: 'Bot',
    colTradeId: 'ID',
    colPair: 'Paire',
    colType: 'Type',
    colLeverage: 'Levier',
    colEntryPrice: "Prix d'entrée",
    colCurrentPrice: 'Prix actuel',
    colProfitPct: 'Profit %',
    colProfitAbs: 'Profit',
    colStake: 'Mise',
    colDuration: 'Durée',
    colOpenSince: 'Ouvert depuis',
    colOpenReason: 'Raison entrée',
    colReplay: 'Replay',
    colStoplossDist: 'Dist. Stoploss',
    colDurationAnomaly: 'Santé durée',
    colOpenDate: "Date d'ouverture",
    colActions: 'Actions',
    colClosePrice: 'Prix de sortie',
    colCloseReason: 'Raison de sortie',
    colCloseDate: 'Date de fermeture',
    colCloseDuration: 'Durée de détention',
    colClosedAgo: 'Fermé il y a',
    colFee: 'Frais',
    durationOk: 'Durée normale (< 24h)',
    durationWarn: 'Durée prolongée (24-72h)',
    durationDanger: 'Durée critique (> 72h)',
    popoverEntry: "Prix d'entrée",
    popoverCurrent: 'Prix actuel',
    popoverClose: 'Prix de sortie',
    popoverProfit: 'Profit',
    popoverDuration: 'Durée',
    popoverStoploss: 'Stoploss',
    popoverLiquidation: 'Liquidation',
    min: 'Min',
    max: 'Max',
    actions: 'Actions',
    actionsFor: 'Actions pour {pair}',
    closeActionsMenu: 'Fermer le menu Actions',
    viewChart: 'Voir le graphique',
    viewOnExchange: "Voir sur l'exchange",
  },

  // Visualiseur de logs amélioré
  logViewer: {
    levelAll: 'Tous',
    levelInfo: 'Info',
    levelWarning: 'Avertissement',
    levelError: 'Erreur',
    hideHeartbeat: 'Masquer heartbeat',
    hideHeartbeatTooltip:
      "Masque les messages periodiques de verification de sante du bot (Bot heartbeat PID=..., state=RUNNING). Ce sont des messages normaux qui n'indiquent aucun probleme.",
    hideWebSocket: 'Masquer WebSocket',
    hideWebSocketTooltip:
      "Masque les messages de connexion/deconnexion WebSocket du serveur API. Ceux-ci se produisent lorsque l'onglet FreqUI se connecte ou se deconnecte.",
    search: 'Rechercher dans les logs...',
    compact: 'Compact',
    autoScroll: 'Défilement auto',
    refresh: 'Recharger les logs',
    scrollToBottom: 'Aller en bas',
    entries: 'entrées',
    noEntries: 'Aucune entrée de log ne correspond aux filtres actuels.',
  },

  // Popover détail de trade
  tradePopover: {
    entryPrice: "Prix d'entrée",
    currentPrice: 'Prix actuel',
    exitPrice: 'Prix de sortie',
    profit: 'Profit',
    duration: 'Durée',
    stake: 'Mise',
    entryTag: "Tag d'entrée",
    dcaHistory: 'Historique DCA',
    entries: 'entrées',
    entriesNoDetail: "entrées (pas de détails d'ordres)",
    priceLevels: 'Niveaux de prix',
    entry: 'Entrée',
    current: 'Actuel',
    exit: 'Sortie',
    sl: 'SL',
    liq: 'Liq.',
    stoplossInfo: 'Info Stoploss',
    initialSl: 'SL initial',
    currentSl: 'SL actuel',
    distancePct: 'Distance %',
    stoploss: 'Stoploss',
    liquidation: 'Liquidation',
    exitInfo: 'Info de sortie',
    exitReason: 'Raison de sortie',
    totalDuration: 'Durée totale',
    durationHealth: 'Santé de la durée',
    currentDuration: 'Actuelle',
    avgAllDuration: 'Moy. (tous)',
    avgWinDuration: 'Moy. (gagnants)',
    avgLoseDuration: 'Moy. (perdants)',
    percentile: 'Percentile',
    fast: 'Rapide',
    slow: 'Lent',
  },

  // Popover santé de la durée
  durationHealth: {
    title: 'Analyse de la santé de la durée',
    current: 'Durée actuelle',
    avgAll: 'Moy. (tous les trades)',
    avgWin: 'Moy. (gagnants)',
    avgLose: 'Moy. (perdants)',
    percentile: 'Percentile',
    sampleSize: 'Basé sur',
    trades: 'trades',
    fast: 'Rapide',
    slow: 'Lent',
    explainClosed:
      'Ce trade est fermé. La durée affichée correspond au temps de détention de la position.',
    explainOk: 'La durée de ce trade est dans la plage normale.',
    explainWarn: 'Ce trade prend plus de temps que la plupart. Surveillez-le de près.',
    explainDanger:
      'Ce trade est ouvert depuis bien plus longtemps que la moyenne. Il est peut-être bloqué.',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: "Pas de données de trades fermés disponibles pour l'analyse.",
  },

  // Stoploss Chart Popover
  stoplossChart: {
    loading: 'Chargement du graphique...',
    loadingPriceData: 'Chargement des prix...',
    unavailable: 'Graphique indisponible',
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: 'Aucune donnée de bougie retournée',
    fetchError: 'Échec de récupération des bougies',
    botNotFound: 'Bot store introuvable',
    tradeTooOld: 'Trade ouvert avant la plage de bougies disponible',
    entryPrice: 'Entrée',
    stoploss: 'Stoploss',
    currentPrice: 'Actuel',
    liquidation: 'Liquidation',
    dcaEntries: 'Entrées DCA',
  },

  // Exit Reason Stats Popover
  exitReasonStats: {
    title: 'Analyse des raisons de sortie',
    exitReason: 'Raison de sortie',
    entryTag: "Tag d'entrée",
    reasonDistribution: 'Raisons de sortie (tous les trades)',
    tagDistribution: "Tags d'entrée (tous les trades)",
  },

  // Type Stats Popover
  typeStats: {
    title: 'Stats Long vs Short',
    long: 'Long',
    short: 'Short',
    count: 'Trades',
    winRate: 'Taux de réussite',
    avgProfit: 'Profit moyen',
  },

  // Leverage Stats Popover
  leverageStats: {
    title: 'Analyse du levier',
    avgLeverage: 'Levier moyen',
    trades: 'trades',
    avg: 'moy',
  },

  // Duration Box Plot Popover
  durationBox: {
    title: 'Distribution des durées',
    median: 'Médiane',
    thisTrade: 'Ce trade',
    sample: 'Échantillon',
    trades: 'trades',
  },

  // Trade detail
  tradeDetail: {
    general: 'Général',
    tradeId: 'ID du trade',
    pair: 'Paire',
    openDate: "Date d'ouverture",
    entryTag: "Tag d'entrée",
    stake: 'Mise',
    totalStake: 'Mise totale',
    amount: 'Quantité',
    openRate: "Prix d'ouverture",
    currentRate: 'Prix actuel',
    closeRate: 'Prix de clôture',
    closeDate: 'Date de clôture',
    realizedProfit: 'Profit réalisé',
    totalProfit: 'Profit total',
    currentProfit: 'Profit actuel',
    closeProfit: 'Profit à la clôture',
    details: 'Détails',
    minRate: 'Prix min',
    maxRate: 'Prix max',
    openFees: "Frais d'ouverture",
    closeFees: 'Frais de clôture',
    stoploss: 'Stop-loss',
    atRisk: 'Capital à risque',
    atRiskDesc:
      "Le montant à risque basé sur la mise. C'est le montant que vous perdriez si le stop-loss est atteint.",
    currentStoplossDist: 'Distance stop-loss actuel',
    initialStoploss: 'Stop-loss initial',
    stoplossLastUpdated: 'Dernière mise à jour du stop-loss',
    direction: 'Direction',
    fundingFees: 'Frais de financement',
    interestRate: "Taux d'intérêt",
    liquidationPrice: 'Prix de liquidation',
    orders: 'Ordres',
  },

  // Bot controls
  controls: {
    startTrading: 'Démarrer le trading',
    stopTrading: 'Arrêter le trading - Arrête aussi la gestion des trades ouverts.',
    pause:
      "Pause (StopBuy) - Freqtrade continuera à gérer les trades ouverts, mais n'ouvrira pas de nouveaux trades.",
    reloadConfig: 'Recharger la config - recharge la configuration y compris la stratégie.',
    forceExitAll: 'Forcer la sortie de tous',
    forceEnter: "Forcer l'entrée - Entrer immédiatement dans un trade à un prix optionnel.",
    stopBot: 'Arrêter le bot',
    stopBotConfirm: "Arrêter la boucle d'exécution du bot ?",
    pauseStopEntering: 'Pause - Arrêter les entrées',
    reload: 'Recharger',
    reloadConfirm: 'Recharger la configuration (y compris la stratégie) ?',
    forceExitAllConfirm: 'Voulez-vous vraiment forcer la sortie de TOUS les trades ?',
  },

  // Force entry form
  forceEntry: {
    title: "Forcer l'entrée d'un trade",
    increasingPosition: 'Augmenter la position pour {pair}',
    orderDirection: "Direction de l'ordre (Long ou Short)",
    pair: 'Paire',
    price: 'Prix [optionnel]',
    stakeAmount: 'Mise en {stake} [optionnel]',
    leverage: 'Levier à appliquer [optionnel]',
    orderType: "Type d'ordre",
    market: 'Marché',
    limit: 'Limite',
    entryTag: "Tag d'entrée personnalisé [optionnel]",
    cancel: 'Annuler',
    enterPosition: 'Entrer en position',
  },

  // Force exit form
  forceExit: {
    title: 'Forcer la sortie',
    exitingTrade: 'Sortie du Trade #{id} {pair}.',
    currentlyOwning: 'Position actuelle : {amount} {currency}',
    amount: 'Quantité en {currency} [optionnel]',
    limitOnly: 'Disponible uniquement avec les ordres limites',
    orderType: "Type d'ordre",
    price: 'Prix',
    cancel: 'Annuler',
    exitPosition: 'Sortir de la position',
  },

  // Settings
  settings: {
    title: 'Paramètres FreqUI',
    uiVersion: "Version de l'interface",
    uiSettings: "Paramètres de l'interface",
    language: 'Langue',
    lockLayouts: 'Verrouiller les dispositions',
    lockLayoutsDesc: 'Verrouiller les dispositions dynamiques pour empêcher tout déplacement.',
    resetLayout: 'Réinitialiser la disposition',
    resetLayoutDesc: "Réinitialiser les dispositions à leur état d'origine.",
    showOpenTrades: "Afficher les trades ouverts dans l'en-tête",
    showOpenTradesDesc: 'Choisir si les trades ouverts doivent être visualisés',
    utcTimezone: 'Fuseau horaire UTC',
    utcTimezoneDesc:
      'Sélectionner le fuseau horaire (UTC recommandé car les exchanges fonctionnent en UTC)',
    backgroundSync: 'Synchronisation en arrière-plan',
    backgroundSyncDesc:
      "Maintenir la synchronisation en arrière-plan pendant qu'un autre bot est sélectionné.",
    confirmDialog: 'Dialogue de confirmation pour les sorties',
    confirmDialogDesc:
      'Utiliser des dialogues de confirmation lors de la fermeture forcée de trades.',
    showMultiPaneText: 'Texte sur les boutons multi-panneaux',
    showMultiPaneTextDesc:
      "Afficher le texte sur les boutons multi-panneaux. Si désactivé, seules les icônes s'affichent.",
    chartSettings: 'Paramètres du graphique',
    chartScaleSide: "Côté de l'échelle",
    left: 'Gauche',
    right: 'Droite',
    chartScaleDesc: "L'échelle doit-elle être affichée à droite ou à gauche ?",
    heikinAshi: 'Utiliser les bougies Heikin Ashi',
    heikinAshiDesc: 'Utiliser les bougies Heikin Ashi dans vos graphiques',
    onlyNecessaryColumns: 'Demander uniquement les colonnes nécessaires',
    onlyNecessaryColumnsDesc: 'Peut réduire la taille du transfert pour les grands DataFrames.',
    defaultCandles: 'Nombre de bougies par défaut (250 par défaut)',
    candleColorPref: 'Préférence de couleur des bougies',
    greenUpRedDown: 'Vert haut / Rouge bas',
    greenDownRedUp: 'Vert bas / Rouge haut',
    notificationSettings: 'Paramètres de notification',
    entryNotifications: "Notifications d'entrée",
    exitNotifications: 'Notifications de sortie',
    entryCancelNotifications: "Notifications d'annulation d'entrée",
    exitCancelNotifications: "Notifications d'annulation de sortie",
    // Browser notifications
    browserNotifications: 'Notifications navigateur',
    enableBrowserNotifications: 'Activer les notifications navigateur',
    enableBrowserNotificationsDesc:
      "Recevoir des notifications navigateur lors du déclenchement d'alertes (perte de position, bot hors ligne, erreurs).",
    notificationsDenied:
      'Les notifications sont bloquées. Veuillez les autoriser dans les paramètres du navigateur.',
    notifyPositionLoss: 'Perte de position dépasse le seuil',
    notifyBotOffline: 'Bot hors ligne',
    notifyLogErrors: 'Erreurs détectées dans les logs',
    backtestSettings: 'Paramètres de backtest',
    backtestMetrics: 'Métriques de backtest',
    backtestMetricsDesc: 'Sélectionner les métriques à afficher par paire / tag.',
    // Dashboard section
    dashboardSettings: 'Tableau de bord',
    // About section
    aboutSection: 'A propos',
    freqtradeVersion: 'Version Freqtrade',
    credits: 'Construit avec FreqUI -- Interface open source pour bot de trading',
  },

  // Performance
  performance: {
    title: 'Performance',
    entries: 'Entrées',
    exits: 'Sorties',
    mixTag: 'Tag mixte',
    pair: 'Paire',
    profitPct: 'Profit %',
    profitStake: 'Profit {stake}',
    count: 'Nombre',
    enterTag: "Tag d'entrée",
    exitReason: 'Raison de sortie',
  },

  // Pairlist
  pairlist: {
    whitelistMethods: 'Méthodes de la whitelist',
    whitelist: 'Liste blanche',
    listUnavailable:
      'Liste indisponible. Veuillez vous connecter et vérifier que le serveur fonctionne.',
    blacklist: 'Liste noire',
    blacklistDesc: "Liste noire - Sélectionnez puis cliquez sur '-' pour retirer des paires",
    addToBlacklist: 'Ajouter une paire à la liste noire',
    selectToDelete: 'Sélectionnez les paires à supprimer de votre liste noire.',
    pair: 'Paire',
  },

  // Pair Locks
  pairLocks: {
    title: 'Verrous de paires',
    pair: 'Paire',
    until: "Jusqu'à",
    reason: 'Raison',
    actions: 'Actions',
    deleteLock: 'Supprimer le verrou',
  },

  // Backtesting
  backtest: {
    title: 'Backtesting',
    mustBeWebserver: 'Le bot doit être en mode webserver pour activer le backtesting.',
    loadResults: 'Charger les résultats',
    runBacktest: 'Lancer le backtest',
    analyzeResult: 'Analyser le résultat',
    compareResults: 'Comparer les résultats',
    visualizeSummary: 'Visualiser le résumé',
    visualizeResult: 'Visualiser le résultat',
    running: 'Backtest en cours',
    params: 'Paramètres du backtest',
    timeframe: 'Timeframe',
    detailTimeframe: 'Timeframe détaillé',
    detailTimeframeDesc: 'Timeframe détaillé pour simuler les résultats intra-bougie.',
    maxOpenTrades: 'Trades ouverts max',
    useStrategyDefault: 'Utiliser la valeur de la stratégie',
    startingCapital: 'Capital initial',
    useConfigDefault: 'Utiliser la valeur de la config',
    stakeAmount: 'Mise',
    unlimitedStake: 'Mise illimitée',
    enableProtections: 'Activer les protections',
    cacheResults: 'Mettre en cache les résultats',
    enableFreqAI: 'Activer FreqAI',
    enableFreqAIDesc:
      'Suppose que FreqAI est configuré et que la stratégie est une stratégie FreqAI.',
    freqAIIdentifier: 'Identifiant FreqAI',
    freqAIModel: 'Modèle FreqAI',
    summary: 'Résumé du backtest',
    resultFor: 'Résultat du backtest pour {strategy}',
    strategySettings: 'Paramètres de la stratégie',
    setting: 'Paramètre',
    value: 'Valeur',
    metrics: 'Métriques',
    resultsPerEnterTag: "Résultats par tag d'entrée",
    resultsPerExitReason: 'Résultats par raison de sortie',
    resultsMixedTag: 'Résultats tag mixte',
    resultsPerPair: 'Résultats par paire',
    periodicBreakdown: 'Ventilation périodique',
    startBacktest: 'Lancer le backtest',
    loadBacktestResult: 'Charger le résultat du backtest',
    stopBacktest: 'Arrêter le backtest',
    resetBacktest: 'Réinitialiser le backtest',
    singleTrades: 'Trades individuels',
    wins: 'Gains',
    draws: 'Nuls',
    losses: 'Pertes',
    avgProfit: 'Profit moyen %',
    totProfitStake: 'Profit total {stake}',
    totProfitPct: 'Profit total %',
  },

  // Period breakdown
  periodBreakdown: {
    title: 'Ventilation par période',
    dailyBreakdown: 'Ventilation journalière',
    days: 'Jours',
    weeks: 'Semaines',
    months: 'Mois',
    years: 'Années',
    weekday: 'Jour de la semaine',
    date: 'Date',
    totalProfit: 'Profit total',
    profitFactor: 'Facteur de profit',
    winRate: 'Taux de réussite',
    absProfit: 'Abs €',
    relProfit: 'Rel %',
    day: 'Jour',
    profit: 'Profit',
    inFiat: 'En {currency}',
    trades: 'Trades',
    profitPct: 'Profit %',
  },

  // Download data
  downloadData: {
    title: 'Téléchargement des données',
    selectPairs: 'Sélectionner les paires',
    pairsFromTemplate: 'Paires depuis le modèle',
    addAllPairs: 'Ajouter toutes les paires depuis la config Pairlist.',
    selectTimeframes: 'Sélectionner les timeframes',
    timeSelection: 'Sélection de la période',
    daysToDownload: 'Jours à télécharger',
  },

  // Bot status
  botStatus: {
    running: 'Freqtrade en cours',
    runningWith: 'En cours avec',
    on: 'sur',
    in: 'en',
    spot: 'spot',
    markets: 'marchés, avec la stratégie',
    stoplossOnExchange: "Le stop-loss sur l'exchange est",
    enabled: 'activé',
    disabled: 'désactivé',
    currently: 'Actuellement',
    forceEntry: "forcer l'entrée",
    dryRun: 'Dry-Run',
    live: 'Live',
    avgProfit: 'Profit moyen',
    tradesAvgDuration: 'Trades, avec une durée moyenne de',
    bestPair: 'Meilleure paire',
    botStartDate: 'Date de démarrage',
    firstTradeOpened: 'Premier trade ouvert',
    lastTradeOpened: 'Dernier trade ouvert',
    profitFactor: 'Facteur de profit',
    tradingVolume: 'Volume de trading',
    strategyParams: 'Paramètres de la stratégie',
  },

  // General
  general: {
    autoRefresh: 'Rafraîchissement auto',
    autoRefreshAll: 'Rafraîchir tous les bots maintenant',
    supported: 'Supporté',
    unsupported: 'Non supporté',
    version: 'Version',
    noBotSelected: 'Aucun bot sélectionné',
    online: 'En ligne',
    offline: 'Hors ligne',
    starting: 'Démarrage en cours...',
    confirmDialogDeactivated:
      'Dialogue de confirmation désactivé, les sorties forcées seront exécutées immédiatement. Soyez prudent.',
  },

  // Trading view
  trading: {
    pairsCombined: 'Paires combinées',
    general: 'Général',
    performance: 'Performance',
    balance: 'Solde',
    timeBreakdown: 'Ventilation temporelle',
    pairlist: 'Liste de paires',
    pairLocks: 'Verrous de paires',
    openTrades: 'Trades ouverts',
    closedTrades: 'Trades fermés',
    tradeDetail: 'Détail du trade',
    chart: 'Graphique',
    multiPane: 'Multi-panneaux',
    status: 'Statut',
    cache: 'Cache',
    openTradesTitle: 'Trades ouverts',
    tradeHistory: 'Historique des trades',
  },

  // Charts view
  charts: {
    settings: 'Paramètres',
    customExchange: 'Exchange personnalisé',
    currentExchange: 'Exchange actuel',
    strategy: 'Stratégie',
    useLiveData: 'Données en direct',
    timeframe: 'Timeframe',
    selectPairs: 'Sélectionner les paires',
    refreshChart: 'Actualiser le graphique',
    multiPair: 'Multi paire',
    hideSimultaneous: 'Masquer entrées même bougie',
    showChartAreas: 'Afficher les zones',
    heikinAshi: 'Heikin Ashi',
    noPairSelected: 'Aucune paire sélectionnée',
    plotConfigurator: 'Configurateur de graphique',
    useLiveDataHint:
      "Utiliser les données en direct de l'exchange. A n'utiliser que si vous n'avez pas de données téléchargées localement.",
    longEntries: 'Entrées long',
    longExits: 'Sorties long',
    shortEntries: 'Entrées short',
    shortExits: 'Sorties short',
    longEntrySignals: "Signaux d'entrée long",
    longExitSignals: 'Signaux de sortie long',
    chartOptions: 'Options du graphique',
    notLoadedYet: 'Pas encore chargé.',
    loading: 'Chargement...',
    noData: 'Aucune donnée disponible',
    loadError: 'Erreur de chargement',
    takingLonger: 'Le chargement prend plus de temps que prévu...',
    loadStrategyIndicators: 'Charger les indicateurs de la stratégie',
    strategyIndicatorsLoaded: 'Indicateurs chargés',
  },

  // Empty states
  emptyStates: {
    noTradesYet: 'Aucun trade',
    noTradesDesc:
      "Ce bot n'a exécuté aucun trade pour le moment. Les statistiques apparaîtront après le premier trade.",
    noOpenPositions: 'Aucune position ouverte',
    noOpenPositionsDesc: 'Tout va bien — aucun capital actuellement à risque.',
    noClosedTrades: 'Aucun trade fermé',
    noClosedTradesDesc:
      'Les statistiques de profit apparaîtront après la fermeture du premier trade.',
    noTradingActivity: 'Aucune activité de trading',
    noTradingActivityDesc: "Ce bot n'a enregistré aucune activité de trading pour le moment.",
    noWinLossData: 'Aucune donnée W/L',
    noWinLossDataDesc:
      'Les statistiques de taux de réussite nécessitent au moins un trade complété.',
    balanceUnavailable: 'Solde indisponible',
    balanceUnavailableDesc: 'Les données de solde ne sont pas disponibles pour ce bot.',
    insufficientHistory: 'Historique insuffisant',
    insufficientHistoryDesc:
      "L'analyse par période nécessite au moins quelques jours d'historique de trading.",
  },

  // Time durations
  time: {
    seconds: '{n} seconde | {n} secondes',
    minutes: '{n} minute | {n} minutes',
    hours: '{n} heure | {n} heures',
    days: '{n} jour | {n} jours',
    lessThanMinute: "moins d'une minute",
    // Compact "ago" form for tight cells (e.g. BotComparison "Last trade" column)
    justNow: "à l'instant",
    minutesAgoShort: 'il y a {n}min',
    hoursAgoShort: 'il y a {n}h',
    daysAgoShort: 'il y a {n}j',
  },

  // Metric tooltips
  tooltips: {
    roi: 'Retour sur investissement - Profit total en % du capital initial',
    winrate: 'Pourcentage de trades profitables',
    cagr: 'Taux de croissance annuel composé - Rendement annualisé avec effet de compounding',
    sharpe:
      'Ratio de Sharpe - Rendement ajusté au risque. Au-dessus de 1 = bon, au-dessus de 2 = excellent',
    sortino: 'Ratio de Sortino - Comme Sharpe mais ne pénalise que la volatilité baissière',
    sqn: 'System Quality Number - Mesure la qualité du système. Au-dessus de 2 = bon, au-dessus de 3 = excellent',
    expectancy: 'Profit moyen attendu par trade',
    profitFactor:
      'Ratio profit brut / perte brute. Au-dessus de 1 = profitable, au-dessus de 2 = bon',
    maxDrawdown: 'Plus grande baisse entre un pic et un creux. Plus bas = mieux',
    currentDrawdown: 'Baisse actuelle depuis le dernier pic',
    avgDuration: "Durée moyenne de détention d'un trade",
    anomalyScore: 'Durée de la position actuelle vs moyenne. Au-dessus de 2x = attention',
    tradingVolume: 'Valeur totale de tous les trades exécutés',
    calmar: 'Ratio de Calmar - CAGR divisé par le drawdown max',
    weightedAvgProfit: 'Profit moyen pondéré par la taille des positions',
    annualizedReturn: 'Rendement annuel projeté basé sur la performance actuelle',
    vsBtc:
      'Compare votre profit total % avec la variation du prix BTC % sur la même période. Positif = vous avez surperformé le simple achat de BTC.',
    periodReturn:
      'Profit total réalisé pendant la période sélectionnée, en montant absolu et en pourcentage du capital initial.',
    capacityUtilization: 'Pourcentage des positions max actuellement utilisées',
    avgWinLossRatio: 'Taille moyenne des gains divisée par la taille moyenne des pertes',
    avgProfitPerTrade: 'Profit moyen en pourcentage sur tous les trades fermés',
    // BotInfoCard
    roiAll: 'Retour incluant les trades ouverts et fermés',
    totalTradeCount: 'Nombre total de trades exécutés depuis le démarrage du bot',
    botStarted: 'Date et heure du premier démarrage du bot',
    firstTrade: 'Date du tout premier trade exécuté',
    latestTrade: 'Date du trade le plus récent',
    winLoss: 'Nombre de trades profitables vs perdants',
    bestPair: 'Paire de trading avec le meilleur ratio de profit',
    withdrawn: 'Montant total retiré des profits du bot',
    netProfit: 'Profit après déduction des retraits',
    // OpenProfitCard
    unrealizedPnl: 'Profit/perte total sur les positions non encore fermées',
    highestLoss: 'Position ouverte avec la plus grande perte non réalisée',
    highestGain: 'Position ouverte avec le plus grand gain non réalisé',
    avgPositionProfit: 'Moyenne simple du profit sur toutes les positions ouvertes',
    totalStakeLocked: 'Capital total actuellement alloué aux positions ouvertes',
    pctOfBotBalance: 'Pourcentage du solde total de ce bot en positions ouvertes',
    pctOfAllBots: 'Mise ouverte de ce bot en part de tous les bots combinés',
    durationAnomaly:
      'Compare la durée actuelle à la durée moyenne des trades fermés. Jaune >1.5x, Rouge >2x',
    // ClosedProfitCard
    realizedProfit: 'Profit total de tous les trades fermés',
    weeklyTrend: 'Tendance de profit hebdomadaire sur la période récente',
    avgPerTrade: 'Profit moyen par trade fermé',
    tradingPeriod: 'Période entre le premier et le dernier trade',
    avgProfitWeek: 'Profit moyen gagné par semaine',
    avgProfitMonth: 'Profit moyen gagné par mois',
    pctOfTotal: 'Part de ce bot dans le profit total de tous les bots sélectionnés',
    // TradesInfoCard
    capacity: 'Nombre de slots de trades utilisés vs maximum autorisé',
    capitalAllocation: 'Total de la devise de mise allouée aux positions ouvertes',
    avgClosedDuration: "Durée moyenne de détention d'un trade fermé",
    tradesPerDay: 'Nombre moyen de trades ouverts par jour',
    tradesPerWeek: 'Nombre moyen de trades ouverts par semaine',
    timeBetweenTrades: 'Temps moyen entre les trades consécutifs',
    timeSinceLastTrade: 'Temps écoulé depuis le dernier trade ouvert',
    unusuallyQuiet:
      "L'activité de trading est significativement en dessous de la fréquence moyenne",
    // BalanceCard
    startingCapital: 'Capital initial configuré pour ce bot',
    balanceGrowth: 'Croissance totale du capital initial au solde actuel',
    capitalInTrades: 'Montant du solde actuellement bloqué dans les positions ouvertes',
    freeCapital: 'Solde disponible pour de nouveaux trades',
    // PeriodProfitCard
    dailyAvg: 'Profit moyen gagné par jour',
    weeklyAvg: 'Profit moyen gagné par semaine',
    monthlyAvg: 'Profit moyen gagné par mois',
    projection1m: 'Profit estimé dans 1 mois au rythme actuel',
    projection3m: 'Profit estimé dans 3 mois au rythme actuel',
    projection1y: 'Profit estimé dans 1 an au rythme actuel',
    // ExchangeInfoCard
    maxLeverage: 'Levier maximum disponible sur cet exchange',
    makerFee: "Frais payés lors du placement d'ordres limites qui ajoutent de la liquidité",
    takerFee: "Frais payés lors du placement d'ordres marché qui retirent de la liquidité",
    kycStatus: 'Exigences de vérification KYC (Know Your Customer)',
    // CurrencyInfoCard
    pegInfo: 'Valeur cible que ce stablecoin vise à maintenir',
    backing: 'Actifs garantissant la valeur de cette devise',
    riskNote: 'Risques connus associés à cette devise',
    botImpact: 'Comment cette devise affecte les calculs de profit de votre bot',
    // Alert detailed tooltips
    alertTooltipPositionLoss:
      'Se déclenche quand une position ouverte a une perte non réalisée dépassant le seuil configuré.',
    alertTooltipPositionStuck:
      'Se déclenche quand une position est détenue beaucoup plus longtemps que la durée moyenne des trades.',
    alertTooltipNearLiquidation:
      "Se déclenche quand une position futures s'approche de son prix de liquidation.",
    alertTooltipLogErrors:
      'Se déclenche quand des messages ERROR ou CRITICAL apparaissent dans les logs du bot.',
    alertTooltipOrderFailed:
      "Se déclenche quand le bot échoue à placer un ordre. Souvent dû à des problèmes d'exchange.",
    alertTooltipInsufficientFunds:
      'Se déclenche quand le bot ne peut pas ouvrir de position par manque de fonds.',
    alertTooltipExchangeError:
      'Se déclenche sur les problèmes de connectivité exchange : timeouts, rate limits.',
    alertTooltipWalletMismatch:
      'Se déclenche quand le bot détecte un écart entre son suivi interne et le wallet.',
    alertTooltipNoTradeActivity:
      "Se déclenche quand aucun nouveau trade n'est ouvert dans le temps configuré.",
    alertTooltipBotOffline: 'Se déclenche immédiatement quand un bot ne répond plus.',
    alertTooltipHighDrawdown:
      'Se déclenche quand le drawdown actuel depuis le pic dépasse le seuil.',
    alertTooltipCapacityFull: 'Se déclenche quand tous les slots de trades sont occupés.',
    alertTooltipAllFundsExposed:
      'Se déclenche quand 95% ou plus du solde est bloqué dans les positions ouvertes.',
    alertTooltipLiquidationBeforeStoploss:
      'Se déclenche quand le prix de liquidation est plus proche que le stoploss. La position serait liquidée avant que le stoploss ne se déclenche.',
    // Additional metric tooltips
    currentStreak: 'Nombre de gains ou pertes consécutifs',
    historicalRange: 'Plage de durée du trade le plus court au plus long',
    medianDuration:
      'Valeur médiane de toutes les durées de trades fermés, moins sensible aux valeurs extrêmes',
    currentBalance: 'Solde total actuel de ce bot',
    bestBot: 'Bot avec le meilleur retour sur investissement',
    worstBot: 'Bot avec le plus faible retour sur investissement',
    avgRoiAllBots: 'ROI moyen de tous les bots sélectionnés',
    totalWithdrawalsAllBots: 'Somme de tous les retraits de tous les bots sélectionnés',
  },

  // Stress Test
  stressTest: {
    title: 'Test de stress',
    estimatedGain: 'Gain total estimé',
    crash: 'crash',
    pump: 'hausse',
    scenarioDesc:
      "En cas de mouvement soudain et instantané du marché, voici ce qu'il adviendrait de vos positions ouvertes actuelles. On part du principe que c'est un mouvement généralisé et que toutes les crypto-monnaies subissent la même fluctuation.",
    estimatedImpact: 'Impact estimé',
    estimatedTotalLoss: 'Perte totale estimée',
    crashScenario: 'Scénario de crash',
    crashOf: 'crash de {pct}%',
    pumpOf: 'hausse de {pct}%',
    noOpenPositions: 'Aucune position ouverte à tester.',
    noOpenPositionsHint: "Le scénario s'appliquera dès qu'un bot ouvrira un trade",
    liquidation: 'LIQUIDATION',
    liquidationWarning: '{count} position(s) serai(en)t liquidée(s)',
    isolatedOnly:
      'Marge isolée uniquement. Ne prend pas en compte les frais de financement, le slippage ou la marge croisée.',
  },

  // Profit Goal
  profitGoal: {
    title: 'Objectif',
    settings: 'Objectif de profit',
    targetAmount: 'Montant cible',
    period: 'Période',
    apply: 'Appliquer',
    monthly: 'Mensuel',
    yearly: 'Annuel',
  },

  // BotInfoCard labels
  botInfoCard: {
    performance: 'Performance',
    timing: 'Timing',
    drawdown: 'Drawdown',
    strategy: 'Stratégie',
    exchange: 'Exchange',
    port: 'Port',
    started: 'Démarré',
    loadingEquity: 'Chargement des données...',
  },

  // AlertDetailCard
  alertDetailCard: {
    alert: 'alerte | alertes',
    liquidationDistance: 'Distance de liquidation',
    problematicPositions: 'Positions problématiques',
    generalAlerts: 'Alertes générales',
    ifClosedNow: 'Si fermé maintenant',
    stakeAtRisk: 'Mise à risque',
    entry: 'Entrée',
    current: 'Actuel',
    remaining: 'restant',
    heldFor: 'Détenu depuis',
    avgDuration: 'moy',
  },

  // ActivityTimeline
  activityTimeline: {
    ago: 'il y a {time}',
    justNow: "à l'instant",
    agoSeconds: 'il y a {n}s',
    agoMinutes: 'il y a {n}m',
    agoHours: 'il y a {n}h',
    agoDays: 'il y a {n}j',
    searchPlaceholder: 'Rechercher paires, bots...',
    allBots: 'Tous les bots',
    compactMode: 'Mode compact',
    noEvents: 'Aucune activité pour le moment',
    opened: 'Ouvert',
    closed: 'Fermé',
    long: 'Long',
    short: 'Short',
    entries: 'entrées',
    dcaAdjustment: 'Ajustement DCA',
    botStatusChange: 'Changement de statut du bot',
    alertTriggered: 'Alerte déclenchée',
    filterOpened: 'Ouvert',
    filterClosedProfit: 'Profit',
    filterClosedLoss: 'Perte',
    filterDca: 'DCA',
    filterBotStatus: 'Bot',
    filterAlert: 'Alerte',
    eventType: {
      trade_opened: 'Trade ouvert',
      trade_closed_profit: 'Trade fermé (profit)',
      trade_closed_loss: 'Trade fermé (perte)',
      bot_status: 'Statut du bot',
      alert: 'Alerte',
      dca: 'Ajustement DCA',
    },
    goToTradeView: 'Aller à la vue Trade pour ce bot',
    annotationExceptional: 'Trade exceptionnel',
    annotationLongDuration: 'Anormalement long',
    annotationLargestTrade: 'Plus gros trade',
    annotationFirstTrade: '(premier trade)',
    annotationBestTrade: '(meilleur trade)',
    annotationWorstTrade: '(pire trade)',
    annotationLongestTrade: '(trade le plus long)',
    allModes: 'Tous les modes',
    liveOnly: 'Live uniquement',
    dryOnly: 'Dry uniquement',
    compactLabel: 'Compact',
    group: {
      today: "Aujourd'hui",
      yesterday: 'Hier',
      thisWeek: 'Cette semaine',
      earlier: 'Plus ancien',
    },
  },

  // Trades Log Enhanced
  tradesLog: {
    allBots: 'Tous les bots',
    filterAll: 'Tous',
    filterOpens: 'Ouvertures',
    filterCloses: 'Fermetures',
    noEntries: 'Aucun événement de trade',
    opened: 'ouvert',
    statTotal: 'Total',
    statOpens: 'Ouvertures',
    statWins: 'Gains',
    statLosses: 'Pertes',
  },

  // Tableau de bord marché
  marketPulse: {
    tf_today: "Aujourd'hui",
    tf_24h: '24h',
    tf_7d: '7 jours',
    tf_thisWeek: 'Cette semaine',
    tf_30d: '30 jours',
    tf_thisMonth: 'Ce mois',
    tf_thisYear: 'Cette année',
    tf_1y: '1 an',
    settings: 'Paramètres',
    defaultTimeframe: 'Période par défaut',
    sectionMarket: 'Indicateurs marché',
    sectionPerformance: 'Performance bots',
    sectionVolume: 'Volume',
    sectionComparison: 'Comparaison',
    fearGreed: 'Peur & Cupidité',
    extremeFear: 'Peur extrême',
    fear: 'Peur',
    greed: 'Cupidité',
    extremeGreed: 'Cupidité extrême',
    botPerformance: 'Performance des bots',
    totalProfit: 'Profit total',
    trades: 'Trades',
    winRate: 'Taux de réussite',
    bestTrade: 'Meilleur trade',
    worstTrade: 'Pire trade',
    bestBot: 'Meilleur bot',
    worstBot: 'Pire bot',
    volume: 'Volume',
    volumeByExchange: 'Par exchange',
    volumeByCurrency: 'Par devise',
    comparison: 'Comparaison',
    yourBots: 'Vos bots',
    beatingBtc: 'Bat le BTC !',
    underperformingBtc: 'Sous-performe le BTC',
    // Popovers
    popoverBtcTitle: 'Prix du Bitcoin',
    popoverPrice: 'Prix',
    popover24hChange: 'Variation 24h',
    popover7dChange: 'Variation 7j',
    popoverSource: 'Source',
    popoverFgTitle: 'Indice Peur & Cupidité',
    popoverFgDescription:
      'Mesure le sentiment du marché de 0 (peur extrême) à 100 (cupidité extrême). Basé sur la volatilité, le volume, les réseaux sociaux, les sondages, la dominance et les tendances.',
    popoverPerf_totalProfit: 'Profit total',
    popoverPerfDesc_totalProfit:
      'Somme des profits de tous les trades clôturés sur la période sélectionnée, convertis dans la devise de synthèse.',
    popoverPerf_trades: 'Nombre de trades',
    popoverPerfDesc_trades:
      'Nombre total de trades clôturés sur la période sélectionnée pour tous les bots sélectionnés.',
    popoverPerf_winRate: 'Taux de réussite',
    popoverPerfDesc_winRate:
      'Pourcentage de trades rentables (profit > 0) parmi tous les trades clôturés sur la période.',
    popoverPerf_bestTrade: 'Meilleur trade',
    popoverPerfDesc_bestTrade:
      'Le trade avec le ratio de profit le plus élevé sur la période sélectionnée.',
    popoverPerf_worstTrade: 'Pire trade',
    popoverPerfDesc_worstTrade:
      'Le trade avec le ratio de profit le plus bas sur la période sélectionnée.',
    popoverPerf_bestBot: 'Meilleur bot',
    popoverPerfDesc_bestBot:
      'Le bot avec le profit absolu total le plus élevé sur la période sélectionnée.',
    popoverPerf_worstBot: 'Pire bot',
    popoverPerfDesc_worstBot:
      'Le bot avec le profit absolu total le plus bas sur la période sélectionnée.',
  },

  // Performance Heatmap
  performanceHeatmap: {
    loadingBenchmarks: 'Chargement des données de benchmark...',
    noData: 'Aucune donnée de trade disponible',
    profit: 'Profit',
    loss: 'Perte',
    tf_day: 'Par jour',
    tf_week: 'Par semaine',
    tf_month: 'Par mois',
  },

  // Risk Overview
  riskOverview: {
    totalExposure: 'Exposition totale',
    netExposure: 'Exposition nette',
    grossExposure: 'Exposition brute',
    currentExposure: 'Exposition actuelle',
    deployed: 'engagé',
    of: 'sur',
    longLabel: 'Long',
    shortLabel: 'Short',
    avgLeverage: 'Levier moyen',
    largestPosition: 'Plus grosse position',
    worstDrawdown: 'Pire drawdown',
    overallPnl: 'PnL ouvert global',
    correlationWarnings: 'Alertes de corrélation',
    // Popovers
    popoverExposureTitle: "Détail de l'exposition",
    popoverExposureDesc: 'Capital actuellement déployé en positions ouvertes, ventilé par bot.',
    popoverDrawdownTitle: 'Pire drawdown',
    popoverDrawdownDesc: 'La position ouverte avec la plus grande perte latente en pourcentage.',
    popoverDrawdownPair: 'Paire',
    popoverDrawdownPct: 'Drawdown',
    popoverDrawdownBot: 'Bot',
    popoverPnlTitle: 'Détail du PnL ouvert',
    popoverPnlDesc: 'Profit/perte latent de toutes les positions ouvertes, ventilé par bot.',
    popoverLeverageTitle: 'Détail du levier',
    popoverLeverageDesc: 'Levier moyen utilisé par chaque bot sur les positions ouvertes.',
    popoverCorrelationTitle: 'Alertes de corrélation',
    popoverCorrelationDesc:
      'Paires tradées simultanément par plusieurs bots, augmentant le risque corrélé.',
    popoverCorrelationNone: 'Aucune paire corrélée détectée.',
    totalBalanceTooltip: 'Solde total de tous les bots sélectionnés',
    riskLow: 'Risque Faible',
    riskModerate: 'Risque Modéré',
    riskHigh: 'Risque Élevé',
    noOpenPositions: 'Aucune position ouverte',
    noOpenPositionsHint: "Les métriques de risque apparaîtront dès qu'un bot ouvrira un trade",
  },

  // Fleet view
  fleet: {
    title: 'Flotte',
    servedBy: 'servi par {bot}',
    refresh: 'Rafraîchir',
    loading: 'Chargement des données de la flotte...',
    walletReconciliation: 'Flotte · Réconciliation wallet',
    allClear: 'tout est OK',
    issueCount: '{count} problème(s)',
    directionalExposure: 'Flotte · Exposition directionnelle',
    pnlContribution: 'Flotte · Contribution au P&L',
    botsPanel: 'Flotte · Bots',
    reconciliationDesc:
      'Compare les positions on-chain du wallet avec la somme des bases de données des bots. Agrégat serveur, rafraîchi toutes les 60 s.',
    exposureDesc:
      'Exposition nette long/short de la flotte entière. Agrégat serveur, rafraîchi toutes les 60 s.',
    pnlDesc:
      'Contribution au P&L de chaque bot sur la flotte entière. Agrégat serveur, rafraîchi toutes les 60 s.',
    botsDesc:
      'Tous les bots de la flotte avec capital, P&L et activité. Agrégat serveur, rafraîchi toutes les 60 s.',
    errors: {
      overviewFailed: "Échec du chargement de la vue d'ensemble de la flotte",
      reconciliationFailed: 'Échec du chargement de la réconciliation',
      noServingBot:
        'Aucun bot connecté ne supporte FleetView. Redémarrez au moins un bot avec le backend à jour.',
      servingBotUnavailable: 'Le bot qui sert FleetView est indisponible.',
      resolveFailed: 'La demande de résolution a échoué',
    },
    botsTable: {
      botCount: '{count} bots',
      capital: 'Capital',
      label1d: '1j',
      label7d: '7j',
      label30d: '30j',
      total: 'Total',
      open: 'Ouverts',
      filterPlaceholder: 'Filtrer bot / stratégie',
      modeLive: 'Live',
      modeDry: 'Dry',
      modeAll: 'Tous',
      colBot: 'Bot',
      colStrategy: 'Stratégie',
      colDirection: 'Dir',
      colCapital: 'Capital',
      colPnl1d: 'P&L 1j',
      colOpen: 'Ouverts',
      colTrades30d: 'Trades 30j',
      colUptime: 'Uptime',
      colAge: 'Âge',
      colPort: 'Port',
      dryTag: 'DRY',
      frozenTitle: 'Gelé (capital effectif <= 0)',
      inertTitle: 'Inerte (aucun trade en 14j)',
      leverageTitle: 'Levier {leverage}x',
      dbUnreadable: 'Base de données illisible',
      durationM: '{m}min',
      durationHM: '{h}h {m}min',
      durationDH: '{d}j {h}h',
    },
    pnl: {
      includeUpnl: 'inclure le uPnL (approx.)',
      sum: 'Somme :',
      nonZeroBots: '{count} bots avec une contribution non nulle',
      noContribution: 'Aucune contribution sur cette fenêtre.',
      window1d: '1j',
      window7d: '7j',
      window30d: '30j',
    },
    exposure: {
      long: 'Long',
      short: 'Short',
      longWord: 'long',
      shortWord: 'short',
      allocatedStake: '(stake alloué, {total} USDC)',
      topNet: 'Top expositions nettes on-chain',
      walletNet: 'Net du wallet :',
      upnlTitle: 'uPnL {upnl} USDC',
      noPosition: 'Aucune position on-chain.',
    },
    reconciliation: {
      liveBots: '{count} bots live',
      secondsAgo: 'il y a {seconds}s',
      minutesAgo: 'il y a {minutes}min',
      noData: 'Aucune donnée de réconciliation.',
      mark: 'mark {price}',
      upnl: 'uPnL',
      dbSays: 'La DB dit',
      onChain: 'On-chain',
      gap: 'Écart',
      sideFlat: 'flat',
      sideLong: 'long',
      sideShort: 'short',
      summaryMinority:
        'La DB et le wallet concordent sur le total ({chainSide} {chainAmount} {coin}), mais {bot} #{tradeId} détient le côté opposé de la position nette : ses sorties sont rejetées en reduce-only.',
      summaryPhantom:
        "La part de {bot} #{tradeId} n'existe pas on-chain : le wallet détient {chainSide} {chainAmount} {coin}, entièrement expliqué par les autres bots. Suppression en DB sûre (aucun ordre exchange).",
      summaryUnowned:
        "Le wallet détient {chainSide} {chainAmount} {coin} mais aucun bot ne revendique cette position.",
      summaryAmbiguous:
        "Les bots revendiquent collectivement {dbSide} {dbAmount} {coin} mais le wallet détient {chainSide} {chainAmount} (écart {gap}). Aucun trade unique n'explique l'écart : voir le guide de résolution.",
      status: {
        phantom: 'fantôme',
        minority: 'minoritaire',
        unowned: 'orpheline',
        ambiguous: 'ambigu',
      },
      hint: {
        phantom:
          "Un bot détient un trade dont la part est prouvablement absente on-chain. Suppression sûre depuis sa DB (aucun ordre sur l'exchange).",
        minority:
          'La DB correspond au on-chain, mais un bot détient le côté OPPOSÉ de la position nette. Ses sorties sont rejetées (reduce-only).',
        unowned:
          'Position on-chain sans bot propriétaire dans aucune DB. Peut être soldée avec un ordre reduce-only.',
        ambiguous:
          'La DB et le on-chain divergent sans cause unique prouvable. Investigation manuelle requise.',
      },
      colBot: 'Bot',
      colTrade: 'Trade',
      colSignedAmount: 'Montant signé',
      colOpenRate: "Prix d'entrée",
      colStake: 'Stake',
      closeMinority: 'Clôturer la part minoritaire',
      deletePhantom: 'Supprimer le trade fantôme ({bot} #{tradeId})',
      flattenReduceOnly: 'Solder (reduce-only)',
      manualOnly: 'Intervention manuelle requise, aucune action automatique disponible.',
      allInSync: 'Les positions DB et on-chain sont synchronisées.',
      coinsInSync: '{count} coins synchronisés',
      guide: {
        title: 'Guide de résolution',
        refreshNow: 'Rafraîchir maintenant',
        refreshFirst:
          "Rafraîchissez deux fois à ~1 min d'intervalle. Si l'écart bouge ou disparaît, c'était un ordre en cours : ne rien faire.",
        dust: "L'écart est de la poussière (~{notional} USDC). Peut être ignoré sans risque. Optionnellement, solder manuellement avec un ordre reduce-only.",
        multiPhantom:
          "{count} trades sont chacun un fantôme possible. Recoupez l'historique des fills de chaque bot sur l'exchange : le vrai fantôme est celui dont le côté est absent on-chain. Ne supprimez que celui-là (suppression DB, aucun ordre).",
        multiPhantomItem: '{bot} #{tradeId} ({amount})',
        partialFill:
          "Fill partiel probablement non enregistré : le trade #{tradeId} de {bot} a enregistré {dbAmount} mais le calcul on-chain implique que seulement {impliedFill} a réellement été rempli. Vérifiez les fills du trade sur l'exchange, puis corrigez le montant en DB, ou appliquez le playbook minoritaire (arrêter le bot, ordre inverse sans reduce-only, clôturer le trade en DB, relancer).",
        staleDb:
          'Rien ne se réconcilie : probablement un bot arrêté dont la DB contient encore des trades ouverts (invisibles pour ce scan). Vérifiez les bases des bots récemment arrêtés avant de toucher à quoi que ce soit.',
        footer:
          'Ne touchez jamais aux stratégies ni au levier pour corriger des problèmes de netting. Revérifiez avec un rafraîchissement forcé après chaque action.',
      },
      dialog: {
        deletePhantomTitle: 'Supprimer le trade fantôme sur {coin}',
        closeMinorityTitle: 'Clôturer la part minoritaire sur {coin}',
        flattenUnownedTitle: 'Solder la position orpheline sur {coin}',
        warnDeletePhantom:
          "Le trade sera supprimé de la base du bot. Aucun ordre n'est placé sur l'exchange.",
        warnCloseMinority:
          'Un ordre au marché SANS reduce-only sera placé pour réaligner le wallet, puis le trade bloqué sera supprimé de la base du bot. Le P&L de ce trade ne sera PAS comptabilisé dans les statistiques du bot.',
        warnFlattenUnowned:
          "Un ordre au marché reduce-only sera placé pour solder la position on-chain. Le reduce-only ne peut que réduire la position, jamais l'inverser.",
        coin: 'Coin',
        bot: 'Bot',
        trade: 'Trade',
        amount: 'Montant',
        estNotional: 'Notionnel est.',
        done: 'Terminé',
        orderResult: "Ordre {id} : rempli {filled} {'@'} {avg} ({notional} USDC)",
        dbDelete: 'Suppression DB :',
        close: 'Fermer',
        cancel: 'Annuler',
        confirm: 'Confirmer',
      },
      realign: {
        button: 'Réaligner la DB',
        title: "Réaligner la DB sur l'on-chain, {coin}",
        dbOnly:
          "Action DB uniquement : aucun ordre ne sera jamais placé sur l'exchange. Seules les bases des bots sont réécrites pour correspondre à la position on-chain.",
        intro:
          "Choisissez quoi faire de chaque part en DB pour que leur somme corresponde à la position nette on-chain. Une seule part peut être ajustée ; les parts fermées sont supprimées entièrement.",
        colAction: 'Action',
        colNewAmount: 'Nouveau montant',
        keep: 'Garder',
        closeOp: 'Fermer',
        adjustOp: 'Ajuster',
        onlyOneAdjust: 'Une seule part peut être ajustée par plan.',
        resulting: 'Somme résultante :',
        target: 'Cible on-chain :',
        withinTolerance: 'concordance (2%)',
        outsideTolerance: 'pas de concordance',
        previewBtn: 'Prévisualiser',
        colBefore: 'Avant',
        colAfter: 'Après',
        colDelta: 'Delta',
        colNotional: 'Notionnel du delta',
        touchedNotional: 'Notionnel touché : {notional} USDC',
        backBtn: 'Retour',
        applyBtn: 'Appliquer (DB seule)',
        resultsTitle: 'Résultats',
      },
    },
  },

  // Summary cards
  summaryCards: {
    bots: 'bots',
    shareOfTotalProfit: 'Part du profit total',
    profitOfTotal: '{profit} sur {total} (tous les bots)',
    pctOfBotBalance: '% du solde de ce bot',
    pctOfAllBotsOpenPositions: '% des positions ouvertes (tous les bots)',
  },

  logWidget: {
    allClear: 'Tout est OK',
    grouped: 'Groupé',
    timeline: 'Chronologique',
    compact: 'Compact',
    hideHB: 'Masquer HB',
    hideWS: 'Masquer WS',
    hideWallet: 'Masquer Wallet',
    filters: 'Filtres',
    resetFilters: 'Réinitialiser les filtres',
    unreachableBots: 'Bots injoignables',
    fetchingLogs: 'Récupération des logs de {count} bots...',
    allBotsOk: 'Tous les {count} bots fonctionnent sans problème',
    noMatch: 'Aucun log ne correspond aux filtres',
    showing: '{shown} sur {total} entrées affichées',
    moreBots: '+{count} bot(s) de plus...',
    showLess: 'Voir moins',
    botsWithoutIssues: '{count} bot(s) sans problème',
    offline: 'hors ligne',
    issues: 'problèmes',
    bots: 'Bots',
    mode: 'Mode',
    market: 'Marché',
    currency: 'Devise',
    tags: 'Tags',
    source: 'Source',
  },

  chartPopoverTitle: 'Niveaux de prix et zones',
  tradeOverview: 'Aperçu du trade',

  corrPopover: {
    doubleExposure: 'Double exposition détectée',
    combinedMargin: 'Marge combinée',
    combinedNotional: 'Notionnel combiné',
    direction: 'Direction',
    sameDirection: 'Même (risque amplifié)',
    oppositeDirection: 'Opposée (couverture)',
    warningSame:
      'Les deux bots tradent dans la même direction. Un mouvement de prix défavorable affecte toutes les positions simultanément — votre risque réel est la somme de toutes les marges, pas ce que chaque bot calcule individuellement.',
    warningOpposite:
      'Les bots tradent dans des directions opposées (un long, un short). Cela couvre partiellement le risque mais vous payez des frais des deux côtés.',
    dismiss: 'Ignorer',
    tradedBy: 'tradé par {bots} (double exposition)',
    notFilterable: 'Non filtrable par date',
  },

  configExport: {
    title: 'Config FreqUI',
    export: 'Exporter la configuration',
    import: 'Importer la configuration',
    importing: 'Importation...',
    restored: '{keys} paramètres restaurés, {bots} bots',
    reloading: 'Rechargement...',
    importDesc:
      'Vous avez une configuration FreqUI sauvegardée ? Importez-la pour retrouver vos bots, disposition et préférences.',
    saves: 'Sauvegarde : bots, disposition, filtres, thème, alertes, benchmarks',
    exportPng: 'Exporter en PNG',
  },

  botList: {
    showLess: 'Voir moins',
    moreBots: '+{count} de plus...',
    title: 'Bots disponibles',
    searchPlaceholder: 'Rechercher un bot…',
    addBot: 'Ajouter un bot',
    addFirstBot: 'Ajouter votre premier bot',
    emptyState: 'Aucun bot connecté pour le moment. Ajoutez-en un pour commencer.',
    viewFlat: 'Passer en liste simple',
    viewGrouped: 'Grouper par dossier',
    noMatches: 'Aucun bot ne correspond aux filtres.',
    autoRefresh: 'Rafraîchissement auto',
    onlineSince: 'actif {duration}',
    dry: 'Dry',
    live: 'Live',
    dryTooltip: 'Mode dry-run — trades simulés, sans argent réel.',
    liveTooltip: 'Mode live — trading avec des fonds réels.',
    spotTooltip: 'Spot : achat et vente uniquement, sans levier ni vente à découvert.',
    futuresTooltip: 'Futures : supporte short, long et trading avec levier.',
    sort: {
      manual: 'Ordre manuel',
      name: 'Nom (A→Z)',
      oldest: 'Plus ancien d’abord',
      newest: 'Plus récent d’abord',
      status: 'Statut',
      mode: 'Mode',
    },
    filter: {
      all: 'Tous',
      live: 'Live',
      dry: 'Dry',
      offline: 'Hors ligne',
    },
    // Dossiers
    ungrouped: 'Sans dossier',
    noFolder: 'Aucun dossier',
    changeFolder: 'Changer de dossier',
    moveToFolder: 'Déplacer vers un dossier',
    removeFromFolder: 'Retirer du dossier',
    noFoldersYet: 'Aucun dossier — créez-en un ci-dessous.',
    newFolder: 'Nouveau dossier',
    newFolderName: 'Nom du dossier',
    createFolder: 'Créer le dossier',
    renameFolder: 'Renommer le dossier',
    deleteFolder: 'Supprimer le dossier',
    emptyFolder: 'Vide — déplacez un bot ici.',
  },

  // Widgets de monitoring des taux
  rateMonitor: {
    rateBudget: 'Budget de taux',
    rateBudgetDesc:
      'Budget de limitation de taux — indique combien de jetons sont disponibles pour les appels API. 100% = budget complet, chaque requête consomme des jetons qui se rechargent au fil du temps. En dessous de 30% = risque de blocage 429.',
    tokenBucket: 'Token Bucket — Budget de limitation',
    tokenBucketAvail: 'Disponible : {avail} / {max} jetons',
    tokenBucketFill: 'Niveau de remplissage : {pct}%',
    tokenBucketExplain:
      "Chaque appel API consomme des jetons. Ils se rechargent automatiquement. Quand ils sont épuisés, les requêtes sont mises en file d'attente pour éviter les erreurs 429.",
    tokenBucketLow: 'Budget faible — risque de limitation',
    requests: 'Requêtes',
    requestsDesc:
      "Total des appels API envoyés à l'exchange dans la fenêtre actuelle (directs + en cache)",
    errors: 'Erreurs',
    errorsDesc:
      'Requêtes échouées — inclut timeouts, erreurs serveur et réseau (hors 429 comptés séparément)',
    avgResponse: 'Moy.',
    avgResponseDesc:
      "Temps de réponse API moyen — durée de réponse de l'exchange pour les requêtes directes (non-cachées)",
    p95Response: 'P95',
    p95ResponseDesc:
      "Temps de réponse au 95ème percentile — 95% des requêtes sont plus rapides. Des valeurs élevées indiquent des réponses lentes occasionnelles de l'exchange.",
    queue: "File d'attente",
    queueDesc:
      "Requêtes en attente dans la file du limiteur de taux — des valeurs élevées signifient que le bot envoie plus de requêtes que l'exchange ne l'autorise",
    exchange: 'Exchange',
    exchangeDesc: "L'exchange auquel ce bot est connecté",
    rateLimitHits: '{count} blocage de taux | {count} blocages de taux',
    backoff: 'Backoff x{factor} — {remaining}s restantes',
    backoffDesc:
      'Le backoff exponentiel est actif — les requêtes sont ralenties pour récupérer du blocage de taux',
    cacheHitRates: 'Taux de cache',
    cacheHitRatesDesc:
      "Pourcentage de requêtes servies depuis le cache local au lieu de l'API exchange. Plus c'est élevé = moins d'appels exchange = moins de pression sur les limites.",
    ohlcvDesc: "Données de bougies (OHLCV) servies depuis le cache vs récupérées de l'exchange",
    tickersDesc: "Tickers de prix en temps réel servis depuis le cache vs récupérés de l'exchange",
    positionsDesc:
      "Données de positions ouvertes servies depuis le cache vs récupérées de l'exchange",
    lowCacheEfficiency: "Faible efficacité du cache — plus d'appels directs à l'exchange",
    topMethods: 'Méthodes principales',
    topMethodsDesc:
      "Méthodes API les plus appelées — montre quels endpoints de l'exchange sont les plus sollicités",
    method: 'Méthode',
    count: 'Nombre',
    cached: 'En cache',
    perBot: 'Par bot',
    noMetrics: 'Aucune métrique de taux disponible',
    noMetricsHint: "Le bot doit être en cours d'exécution pour collecter les données",
    window: 'Fenêtre',
    methods: '{count} méthodes',
    flow: 'Flux',
    table: 'Tableau',
    noFlowData: 'Pas assez de données pour le diagramme de flux',
    noMethodData: 'Aucune donnée de méthode disponible',
    waitingActivity: "En attente d'activité API",
    noTimeline: 'Pas de données temporelles',
    responseTime: 'Temps de réponse',
    avgResponseTime: 'Temps de réponse API moyen sur toutes les méthodes',
    direct: 'Direct (API)',
    directDesc: "Requêtes envoyées directement à l'API de l'exchange",
    cachedDesc: "Requêtes servies depuis le cache local sans appeler l'exchange",
    errorsChartDesc: 'Requêtes échouées affichées en barres',
    req: 'req',
    '429s': '429s',
  },

  // Cache Health widget
  cacheHealth: {
    title: 'Santé du cache',
    hitRate: 'Taux de succès',
    totalRequests: 'Total requêtes',
    cacheHits: 'Succès cache',
    cacheMisses: 'Échecs cache',
    gets: 'Lectures',
    hits: 'Succès',
    puts: 'Écritures',
    entries: 'Entrées',
    clients: 'Clients',
    cached: 'En cache',
    cachedFtcache: 'Cache ftcache',
    cachedFtpairlist: 'Cache ftpairlist',
    directToExchange: "Direct à l'exchange",
    breakdown: 'Répartition des requêtes',
    breakdownDesc:
      "Comment les requêtes sont réparties entre les couches de cache et les appels directs à l'exchange",
    exchangeCapacity: 'Capacité exchange',
    capacityDesc:
      "Appels API directs vs capacité de l'exchange. Des valeurs élevées indiquent que le bot est proche de la limite.",
    directLoad: 'Charge API directe',
    exchangeMax: 'Max exchange',
    ftcacheExplain:
      'ftcache : daemon de cache OHLCV/ticker/position local qui réduit les appels API en servant les données répétées depuis la mémoire',
    ftpairlistExplain:
      'ftpairlist : daemon de cache de pairlist partagé qui évite les récupérations redondantes entre plusieurs instances de bots',
    entriesDesc: "Nombre d'entrées de pairlist actuellement stockées dans le cache",
    clientsDesc: "Nombre d'instances de bots connectées au cache de pairlist",
    gaugeExplain0: "0% = aucune requête servie depuis le cache (tout va directement à l'exchange)",
    gaugeExplain100:
      "100% = toutes les requêtes servies depuis le cache (aucun appel direct à l'exchange)",
    noData: 'Aucune donnée de cache disponible',
    noDataHint: "Les daemons de cache doivent être en cours d'exécution",
  },

  // Infrastructure Health widget
  infraHealth: {
    title: 'Infrastructure',
    bot: 'Bot',
    state: 'État',
    pairs: 'Paires',
    uptime: 'Uptime',
    hb: 'HB',
    events: 'Événements',
  },

  // Strategy Development Center
  strategyDev: {
    title: 'Développement Stratégie',
    noRunSelected: 'Sélectionnez un run dans la barre latérale pour voir les détails.',
    selectRunHint: 'Sélectionnez un run dans la barre latérale',
    shortcutSearch: 'Rechercher',
    shortcutSidebar: 'Barre latérale',
    shortcutNavigate: 'Naviguer les runs',
    shortcutDeselect: 'Désélectionner',
    noRuns: 'Aucun run trouvé.',
    loading: 'Chargement des runs...',
    search: 'Rechercher des stratégies...',
    allTypes: 'Tous',
    groupByType: 'Par type',
    groupByStrategy: 'Par stratégie',
    allStrategies: 'Toutes les stratégies',
    filterByType: 'Filtrer par type',
    filterByStrategy: 'Filtrer par stratégie',
    filterByDate: 'Filtrer par date',
    dateAll: 'Toutes les dates',
    date24h: 'Dernières 24h',
    date48h: 'Dernières 48h',
    date7d: '7 derniers jours',
    date14d: '14 derniers jours',
    date30d: '30 derniers jours',
    date3m: '3 derniers mois',
    date6m: '6 derniers mois',
    date1y: 'Dernière année',

    backtest: 'Backtest',
    hyperopt: 'Hyperopt',
    wfa: 'Walk-Forward',
    liveBots: 'Bots',

    // Live bot
    liveScorecardTitle: 'Résultats Live',
    liveSimBanner: '{count} trade(s) ouvert(s) simulé(s) comme fermé(s) au prix actuel',
    liveRefresh: 'Rafraîchir',
    liveBotInfo: 'Informations du Bot',
    liveSummary: 'Résumé de Performance',
    liveExchange: 'Exchange',
    liveMode: 'Mode',
    liveDryRun: 'Dry Run',
    liveReal: 'Réel',
    liveTimeframe: 'Timeframe',
    liveMaxTrades: 'Max Trades',
    liveNoTrades: 'Aucun trade disponible pour ce bot.',

    // Job Launcher
    jobLaunch: 'Lancer un Job',
    jobTypeLabel: 'Type de Job',
    jobBaseConfig: 'Configuration de base',
    jobConfig: 'Fichier Config',
    jobSelectConfig: 'Sélectionner une config...',
    jobStrategy: 'Stratégie',
    jobSelectStrategy: 'Sélectionner une stratégie...',
    jobDateFrom: 'Date de début',
    jobDateTo: 'Date de fin',
    jobTimerange: 'Période',
    jobTimeframe: 'Timeframe',
    jobTimeframeDesc:
      'Timeframe des bougies pour la stratégie. Remplace la valeur de la config. Ex : 15m pour du scalping, 1h pour du swing. La stratégie doit avoir été conçue pour ce timeframe.',
    jobMaxOpenTrades: 'Max Open Trades',
    jobMaxOpenTradesDesc:
      'Nombre max de positions ouvertes simultanément. Remplace la config. Ex : 3 = max 3 trades à la fois. Impact direct sur le capital engagé (stake × MOT).',
    jobStakeAmount: 'Stake Amount',
    jobStakeAmountDesc:
      'Montant misé par trade en devise de stake. Valeurs possibles : nombre (ex : 100), "unlimited" (sizing dynamique via custom_stake_amount). Remplace la config.',
    jobDryRunWallet: 'Dry Run Wallet',
    jobDryRunWalletDesc:
      'Capital de départ simulé en USDT. Ex : 1000 = simulation avec 1000 USDT. Définit la taille du portefeuille pour le calcul des positions et du drawdown.',
    jobEnableProtections: 'Protections',
    jobEnableProtectionsDesc:
      'Active les protections configurées dans la stratégie (CooldownPeriod, StoplossGuard, MaxDrawdown, etc.). Ralentit le backtest mais simule le comportement réel du bot.',
    // Common advanced
    jobAdvancedParams: 'Paramètres avancés',
    jobDataFormat: 'Format données',
    jobDataFormatDesc:
      'Format de stockage des données OHLCV sur disque. feather (défaut) = rapide et compact. parquet = compatible Spark/BigQuery. json/jsongz = lisible humainement.',
    jobFee: 'Frais (fee)',
    jobFeeDesc:
      "Ratio de frais appliqué à l'entrée ET à la sortie. Ex : 0.001 = 0.1% par trade (0.2% aller-retour). Laisser vide = utilise les frais de l'exchange (recommandé).",
    jobPairs: 'Paires',
    jobPairsDesc:
      'Limiter à des paires spécifiques, séparées par virgule. Ex : BTC/USDT:USDT, ETH/USDT:USDT. Ignore la pairlist de la config. Utile pour tester une stratégie sur une seule paire.',
    jobPositionStacking: 'Position Stacking',
    jobPositionStackingDesc:
      "Permet d'ouvrir plusieurs positions sur la même paire (DCA). Attention : les résultats ne sont pas reproductibles en live si le bot ne supporte pas le stacking.",
    jobTimeframeDetail: 'Timeframe détail',
    jobTimeframeDetailDesc:
      "Sous-résolution pour simuler les entrées/sorties intra-bougie. Ex : timeframe=1h + detail=5m → simule le mouvement de prix en 5m à l'intérieur de chaque bougie 1h. Plus lent mais plus précis.",
    // Backtest-only
    jobBacktestParams: 'Paramètres Backtest',
    jobExportType: 'Export',
    jobExportTypeDesc:
      "Données exportées dans le fichier résultat. trades (défaut) = liste des trades. signals = trades + signaux buy/sell sur chaque bougie. none = pas d'export.",
    jobBreakdown: 'Ventilation',
    jobBreakdownDesc:
      "Découpe les résultats par période temporelle. day = profit/jour, week = profit/semaine, month = profit/mois. Permet d'identifier les périodes de sous-performance.",
    jobCache: 'Cache',
    jobCacheDesc:
      'Réutilise un résultat en cache si le dernier run date de moins de N. day (défaut) = 24h. none = force le recalcul. Utile pour itérer rapidement sans relancer le backtest.',
    jobDynamicPairlist: 'Pairlist dynamique',
    jobDynamicPairlistDesc:
      'Rafraîchit la pairlist à chaque nouvelle bougie (ex : VolumePairList recalculé). Plus réaliste mais beaucoup plus lent. Nécessaire si votre pairlist filtre par volume récent.',
    jobNotes: 'Notes',
    jobNotesDesc:
      'Texte libre sauvegardé dans le fichier résultat. Ex : "Test sans SL avec nouveau DCA". Visible dans l\'historique des runs.',
    // Hyperopt params
    jobHyperoptParams: 'Paramètres Hyperopt',
    jobEpochs: 'Époques',
    jobEpochsDesc:
      "Nombre de combinaisons de paramètres testées. 300-500 = exploration initiale. 1000+ = optimisation fine. Plus d'epochs = meilleur résultat mais plus long. Temps ≈ epochs × durée_backtest / workers.",
    jobLoss: 'Fonction de perte',
    jobLossDesc:
      'Définit ce que "meilleur" signifie. CalmarHyperOptLoss = profit/max drawdown (DCA). SharpeHyperOptLoss = rendement ajusté risque (momentum). MoutonMeanRev = custom DCA/mean-reversion. SortinoHyperOptLoss = pénalise uniquement la volatilité baissière.',
    jobSampler: 'Sampler',
    jobSamplerAuto: 'Auto (défaut)',
    jobSamplerDesc:
      "Algorithme d'exploration. NSGA-III (défaut) = génétique, bonne diversité, idéal multi-metric. TPE = bayésien, convergence rapide, idéal 300-500 epochs + loss simple. CMA-ES = gradient-free pour paramètres continus. GP = gaussien, lent si >10 params.",
    jobSpaces: 'Espaces',
    jobSpacesDesc:
      "Espaces de paramètres à optimiser. default = buy+sell+roi+stoploss. all = tout. Sélection multiple possible. buy/sell = signaux d'entrée/sortie. roi/stoploss/trailing = table ROI et stops.",
    jobEarlyStop: 'Arrêt anticipé',
    jobEarlyStopDesc:
      'Arrête si aucune amélioration après N époques. Ex : 150 = stop après 150 epochs sans progrès. Bonne valeur : 20-30% du total epochs. 0 = désactivé. Trop bas = arrêt prématuré.',
    jobMinTrades: 'Trades minimum',
    jobMinTradesDesc:
      'Époques avec moins de N trades reçoivent le score max (pire). Ex : 30 = minimum 30 trades pour être évalué. < 30 = statistiquement non fiable. Monter à 50-100 pour des résultats robustes.',
    jobWorkers: 'Workers',
    jobWorkersDesc:
      'Processus parallèles. -1 = tous les CPUs (plus rapide, RAM élevée). -2 = tous sauf un (laisse le système respirer). 1 = séquentiel (debug/faible RAM). Chaque worker charge une copie des données → RAM × workers.',
    jobRandomState: 'Random State',
    jobRandomStateDesc:
      'Fixe la graine aléatoire pour des résultats reproductibles. Ex : 42. Sans seed, chaque run explore des combinaisons différentes. Utile pour comparer des loss functions ou samplers entre eux.',
    jobPrintAll: 'Afficher tout',
    jobPrintAllDesc:
      "Affiche tous les résultats dans les logs, pas seulement les meilleurs. Utile pour analyser la distribution des résultats et détecter l'overfitting.",
    jobDisableParamExport: 'Désactiver export params',
    jobDisableParamExportDesc:
      "Ne pas créer automatiquement le fichier Strategy.json avec les meilleurs paramètres. Utile si vous voulez comparer avant d'écraser les params existants.",
    jobIgnoreMissingSpaces: 'Ignorer espaces vides',
    jobIgnoreMissingSpacesDesc:
      "Supprime les erreurs si un espace demandé ne contient aucun paramètre optimisable. Ex : --spaces trailing mais la stratégie n'a pas de trailing params.",
    jobAnalyzePerEpoch: 'Analyse par epoch',
    jobAnalyzePerEpochDesc:
      "Relance populate_indicators() à chaque epoch au lieu d'une seule fois. Nécessaire si vos indicateurs dépendent des hyperparamètres. Beaucoup plus lent.",
    // WFA params
    jobWfaParams: 'Paramètres Walk-Forward',
    jobWfWindows: 'Fenêtres',
    jobWfWindowsDesc:
      'Nombre de fenêtres train/test. 3-5 pour 1-2 ans de données, 5-8 pour 3+ ans. Plus de fenêtres = validation plus robuste mais périodes test plus courtes.',
    jobWfTrainRatio: 'Ratio train',
    jobWfTrainRatioDesc:
      "Fraction des données utilisée pour l'entraînement. 0.75 = 75% train, 25% test. Ex : sur 1 an, 9 mois train + 3 mois test par fenêtre. Plage : 0.5 → 0.9.",
    jobWfEmbargo: 'Embargo (jours)',
    jobWfEmbargoDesc:
      'Gap en jours entre données train et test pour éviter le lookahead bias via les indicateurs retardés. 7 jours = safe pour timeframes daily. 1-2 jours pour intraday.',
    jobWfHoldout: 'Holdout (mois)',
    jobWfHoldoutDesc:
      "Réserve N mois à la fin comme validation finale indépendante, jamais touchée par l'optimiseur. 2-3 mois recommandés. 0 = désactivé.",
    jobWfMinTrades: 'Trades min test',
    jobWfMinTradesDesc:
      "Minimum de trades par fenêtre test pour significativité statistique. < 30 = non fiable. La fenêtre est marquée comme invalide si le seuil n'est pas atteint.",
    jobWfMode: 'Mode',
    jobWfModeDesc:
      'rolling (défaut) = fenêtres glissantes de taille fixe. anchored = le train commence toujours au début (plus de données, moins de stationnarité). cpcv = Combinatorial Purged CV, teste toutes les combinaisons possibles.',
    jobWfMultiSeed: 'Multi-Seed',
    jobWfMultiSeedDesc:
      "Lance N hyperopts avec des seeds différents sur la dernière fenêtre. Si les résultats divergent beaucoup, l'espace d'optimisation est bruité → résultats fragiles. 0 = désactivé.",
    jobWfCpcvGroups: 'Groupes CPCV',
    jobWfCpcvGroupsDesc:
      'Nombre de blocs temporels pour le mode CPCV. C(N,K) combinaisons. Ex : N=6, K=2 → C(6,2)=15 combinaisons. Plus de groupes = plus de combinaisons mais blocs plus courts.',
    jobWfCpcvTestGroups: 'Groupes test CPCV',
    jobWfCpcvTestGroupsDesc:
      'Blocs test retenus par combinaison CPCV. K=2 avec N=6 → 15 combinaisons et 5 chemins de backtest. Seulement utilisé avec mode=cpcv.',
    // Job actions & status
    jobStart: 'Lancer',
    jobAbort: 'Annuler',
    jobConfirmAbort: 'Confirmer annulation',
    jobShowLogs: 'Voir les logs',
    jobHideLogs: 'Masquer les logs',
    jobRunning: 'En cours',
    jobHistory: 'Jobs récents',
    jobTabConfig: 'Configuration',
    jobTabConsole: 'Console',
    jobConsoleEmpty: "Aucun job en cours. Lancez un job depuis l'onglet Configuration.",
    jobConsoleDuration: 'Durée',
    jobConsoleFinished: 'Terminé',
    editorSave: 'Sauvegarder',
    editorUseConfig: 'Utiliser cette config',
    editorEditConfig: 'Éditer',
    editorEditStrategy: 'Éditer',
    editorCustomConfig: 'Custom',
    editorModifiedWarning: 'Édition directe du fichier source de la stratégie',
    reconstitute_backtest: 'Reconstituer ce backtest',
    reconstitute_hyperopt: 'Reconstituer cet hyperopt',
    reconstitute_wfa: 'Reconstituer ce walk-forward',
    reconstitute_hint: 'Ouvre le lanceur avec les paramètres pré-remplis de ce run',
    liveBacktest: 'Backtester cette période live',
    liveBacktestHint: 'Ouvre un backtest pré-rempli avec la config et la période de ce bot',
    jobStatus_pending: 'En attente',
    jobStatus_running: 'En cours',
    jobStatus_completed: 'Terminé',
    jobStatus_failed: 'Échoué',
    jobStatus_aborted: 'Annulé',

    tabOverview: 'Aperçu',
    tabCharts: 'Graphiques',
    tabParameters: 'Paramètres',
    tabConfig: 'Config',
    tabSourceCode: 'Code Source',
    tabCommand: 'Commande',
    tabAnalytics: 'Analytics',
    tabAnalyse: 'Analyse',
    tabGraphiques: 'Graphiques',

    // Plot Profit & Plot Dataframe
    plotProfitTitle: 'Graphique de Profit',
    plotDataframeTitle: 'Analyse par Pair',
    plotSelectPair: 'Sélectionner une pair',
    plotCombinedProfit: 'Profit Combiné',
    plotProfitPerPair: 'Profit par Pair',
    plotParallelism: 'Parallélisme des Trades',
    plotUnderwaterAbs: 'Underwater (Absolu)',
    plotUnderwaterPct: 'Underwater (Relatif %)',
    plotMaxDrawdown: 'Zone de Drawdown Max',
    plotNoOhlcv: 'Données OHLCV non disponibles sur le disque',
    plotLoadingStrategy: 'Chargement des indicateurs de la stratégie...',
    plotLoadingProfit: 'Calcul du graphique de profit...',
    plotLoadingDataframe: 'Chargement des données de la pair...',
    plotNoData: 'Aucune donnée disponible',

    // Analytics avancées
    aaLoadingAnalytics: 'Calcul des analytics de performance (meilleur epoch)...',
    aaSectionTitle: 'Analytics de Performance',
    aaBestEpochBanner: 'Meilleur Epoch',
    navDiagnostic: 'Diagnostic',
    navEquity: 'Équité & Drawdowns',
    navPerformance: 'Performance',
    navTrades: 'Trades',
    navRisk: 'Risque',
    navConsistency: 'Consistance',
    navRobustness: 'Robustesse',
    navParameters: 'Paramètres',
    aaSectionEquityDrawdowns: 'Équité & Drawdowns',
    aaSectionReturns: 'Analyse des Rendements',
    aaSectionTradeAnalysis: 'Analyse des Trades',
    aaSectionRisk: 'Évaluation des Risques',
    aaEquityCurve: "Courbe d'Équité",
    aaUnderwaterPlot: 'Graphique Underwater',
    aaMonthlyReturns: 'Rendements Mensuels',
    aaRollingMetrics: 'Métriques Glissantes',
    aaTradePnl: 'Distribution PnL des Trades',
    aaRiskMetrics: 'Métriques de Risque',
    aaDrawdownDetails: 'Analyse des Drawdowns',
    aaStreaks: 'Séries Gains/Pertes',
    aaPairProfit: 'Distribution des Profits par Paire',
    hintEquityCurve:
      "Balance du portefeuille dans le temps. Montre l'évolution de la valeur du compte durant la période de backtest. Les chutes abruptes indiquent des drawdowns.",
    eqStrategy: 'Stratégie',
    eqBtcBenchmark: 'Benchmark BTC',
    hintUnderwater:
      'Drawdown continu sous le plus haut historique. Montre le pourcentage de baisse depuis le pic de balance. Plus le rouge est profond, plus la stratégie est en difficulté.',
    hintMonthlyReturns:
      'Heatmap calendaire des rendements mensuels. Vert = positif, rouge = négatif. Aide à identifier les patterns saisonniers et la régularité entre les mois.',
    hintRollingMetrics:
      "Sharpe, Sortino et volatilité calculés sur une fenêtre glissante de 30 jours. Révèle comment la performance ajustée au risque évolue dans le temps — un Sharpe stable est plus fiable qu'un Sharpe erratique.",
    hintTradePnl:
      "Distribution des rendements individuels par trade. Une distribution asymétrique à droite avec une longue queue positive est idéale. La séparation rouge/vert montre l'équilibre gains/pertes.",
    hintRiskMetrics:
      'Métriques de risque avancées inspirées de VectorBT Pro. VaR = pire perte journalière attendue à 95% de confiance. CVaR = perte moyenne au-delà du VaR. Omega = ratio gains/pertes pondéré par probabilité. Kelly = fraction de mise optimale.',
    hintDrawdownDetails:
      "Top 5 des drawdowns les plus profonds avec durée de déclin/récupération. Des temps de récupération longs indiquent que la stratégie peine à rebondir. Les drawdowns actifs n'ont pas encore de récupération.",
    hintStreaks:
      "Plus longues séries consécutives de gains et de pertes. Les longues séries de pertes testent la gestion du risque et l'endurance psychologique. La distribution montre la fréquence de chaque longueur de série.",

    // Descriptions métriques de risque
    descVar95: 'Pire perte journalière attendue à 95% de confiance',
    descCvar95: 'Perte moyenne dans les 5% pires journées',
    descOmega: 'Ratio gains/pertes (>1 = profitable)',
    descTailRatio: 'Queue droite vs gauche (>1 = plus de hausse)',
    descUlcer: 'Intensité des drawdowns (plus bas = moins douloureux)',
    descRecovery: 'Profit net / drawdown max (>1 = récupéré)',
    descGainPain: 'Gains totaux / pertes totales',
    descKelly: 'Fraction optimale de mise du capital',

    // Tier 2
    aaDurationScatter: 'Durée vs Profit',
    aaExitReasons: 'Détail des Sorties',
    aaWeekdayPattern: 'Pattern Jour de la Semaine',
    aaCumulativeTrades: 'Rendements Cumulés',
    aaSectionTiming: 'Timing & Patterns',
    hintDurationScatter:
      'Chaque point est un trade. X = durée, Y = profit. Révèle si les trades longs sont plus rentables ou si les sorties rapides dominent.',
    hintExitReasons:
      'Comment les trades se clôturent et le profit moyen par type de sortie. Une bonne stratégie a des sorties diversifiées et profitables.',
    hintWeekdayPattern:
      'Performance par jour de la semaine. Révèle si la stratégie a un biais journalier. Le crypto trade 24/7 mais les patterns de liquidité créent des effets.',
    hintCumulativeTrades:
      'Profit cumulé par trade. Une courbe ascendante régulière = edge constant. Les chutes brutales indiquent des pertes groupées.',

    // Tier 3
    aaRollingWinrate: 'Win Rate Glissant',
    aaRollingProfitFactor: 'Profit Factor Glissant',
    aaLongShort: 'Long vs Short',
    aaExposure: 'Exposition des Positions',
    exposureYAxis: 'Positions Ouvertes',
    aaExpectancy: 'Espérance de Trade',
    aaSectionRollingPerf: 'Performance Glissante',
    aaSectionStructure: 'Structure de la Stratégie',
    hintRollingWinrate:
      'Win rate calculé sur une fenêtre glissante de 50 trades. Une ligne stable au-dessus de 50% = edge constant. Les chutes signalent des changements de régime.',
    hintRollingProfitFactor:
      'Profit factor (gains bruts / pertes brutes) sur fenêtre de 50 trades. Au-dessus de 1.0 = profitable. Plus stable = plus robuste.',
    hintLongShort:
      'Compare la performance des trades long et short. Pour les stratégies directionnelles, un côté domine souvent. Grande asymétrie = stratégie unidirectionnelle.',
    hintExposure:
      'Nombre de positions ouvertes simultanément. Les pics = concentration du capital. Exposition stable = utilisation prévisible du capital.',
    hintExpectancy:
      "Profit attendu par trade avec intervalle de confiance. SQN mesure la fiabilité de l'edge. Kelly % suggère le sizing optimal.",

    // Mode toggle
    modeGlobal: 'Analyse Globale',
    modeEpoch: 'Par Epoch',
    modeCompare: 'Comparer',

    // Sélecteur d'epoch
    epochSelectorLabel: 'Top 10 Epochs (par loss)',
    epochSelectPrompt: 'Sélectionnez un epoch ci-dessus pour voir son analyse détaillée',

    // Mode comparaison
    compareLeft: 'Epoch gauche',
    compareRight: 'Epoch droite',
    compareParams: 'Différences de paramètres',
    compareMetric: 'Métrique',
    compareParameter: 'Paramètre',
    compareRankN: 'Rang {n}',

    // Nouveaux graphiques
    aaReturnDistribution: 'Distribution des Rendements',
    aaDrawdownCalendar: 'Calendrier de Drawdown',
    aaMaeMfe: 'MAE / MFE Scatter',
    hintReturnDistribution:
      'Histogramme des rendements par trade superposé à une distribution normale. Les écarts à la normalité (skew, queues épaisses) révèlent des risques cachés.',
    hintDrawdownCalendar:
      'Intensité du drawdown journalier en heatmap calendrier. Cellules foncées = drawdown profond. Aide à identifier les patterns saisonniers et les périodes de pertes prolongées.',
    hintMaeMfe:
      'Maximum Adverse Excursion (MAE) et Maximum Favorable Excursion (MFE) vs PnL final. MAE = pire drawdown intra-trade ; MFE = meilleur gain non-réalisé. Aide à optimiser le stop-loss et take-profit.',

    // Sections analyse backtest
    btNavSummary: 'Résumé',
    btNavEquity: 'Equity & Drawdowns',
    btNavPerformance: 'Performance',
    btNavTrades: 'Trades',
    btNavRisk: 'Risque',
    btNavConsistency: 'Consistance',
    btNavPairs: 'Paires',
    btNavConfig: 'Configuration',
    btScorecardTitle: 'Résultats du Backtest',
    btScorecardDD: 'DD Max',
    btScorecardWinrate: 'Taux de Réussite',

    btHourlyPattern: 'Pattern Horaire',
    hintBtHourlyPattern:
      "Profit moyen et winrate par heure (0-23). Révèle les patterns intra-journaliers — quelles heures génèrent le plus d'alpha.",
    btCapitalUtilization: 'Utilisation du Capital',
    hintBtCapitalUtilization:
      'Pourcentage du capital disponible déployé dans le temps. Faible utilisation = capital dormant ; très haute = opportunités potentiellement manquées.',
    btPairHeatmap: 'Matrice de Performance par Paire',
    hintBtPairHeatmap:
      'Tableau triable des métriques par paire. Cellules colorées pour identifier les meilleurs et pires performers.',
    btBenchmark: 'Stratégie vs Buy & Hold',
    hintBtBenchmark:
      "Comparaison d'equity entre la stratégie et un simple buy-and-hold. Alpha = surperformance de la stratégie par rapport au benchmark.",

    btBestPair: 'Meilleure Paire',
    btWorstPair: 'Pire Paire',
    btTradesPerDay: 'Trades / Jour',
    btMarketChange: 'Évolution du Marché',
    btWinLossDays: 'Jours Gain / Perte / Neutre',
    btHoldingAvg: 'Holding Moyen',
    btWinnerHolding: 'Holding Gagnants',
    btLoserHolding: 'Holding Perdants',
    btExpectancy: 'Espérance',
    btExpectancyRatio: "Ratio d'Espérance",
    btFinalBalance: 'Solde Final',

    btOrderStats: "Statistiques d'Ordres",
    btRejectedSignals: 'Signaux Rejetés',
    btTimedoutEntry: 'Entrées Expirées',
    btTimedoutExit: 'Sorties Expirées',
    btCanceledEntries: 'Entrées Annulées',

    btConfigGeneral: 'Général',
    btConfigTimeframe: 'Timeframe',
    btConfigTimerange: 'Plage Temporelle',
    btConfigMaxOpenTrades: 'Max Open Trades',
    btConfigDays: 'Jours de Backtest',
    btConfigStart: 'Date de Début',
    btConfigEnd: 'Date de Fin',
    btConfigStoploss: 'Stoploss & Trailing',
    btConfigTrailing: 'Trailing Stop',
    btConfigTrailingPositive: 'Trailing Positif',
    btConfigTrailingOffset: 'Trailing Offset',
    btConfigRoi: 'Table ROI',
    btConfigRoiMinutes: 'Minutes',
    btConfigRoiReturn: 'Rendement',
    btConfigMarket: 'Contexte Marché',

    // Noms des jours
    dayMon: 'Lun',
    dayTue: 'Mar',
    dayWed: 'Mer',
    dayThu: 'Jeu',
    dayFri: 'Ven',
    daySat: 'Sam',
    daySun: 'Dim',

    // Weekday pattern chart
    wdTotalProfit: 'Profit Total',
    wdWinRate: 'Taux de Gain',
    wdTrades: 'Trades',
    wdAvgProfit: 'Profit Moyen',

    // Exit reason chart
    erCount: 'Nombre',
    erAvgProfit: 'Profit Moyen %',
    erWinRate: 'Taux de Gain',
    erTotalProfit: 'Profit Total',

    // Convergence chart
    convEpochLoss: "Loss de l'epoch",
    convBestSoFar: "Meilleur jusqu'ici",
    convEpoch: 'Epoch',
    convLoss: 'Loss',

    // Séries
    skMaxWinStreak: 'Série Max Gains',
    skMaxLossStreak: 'Série Max Pertes',
    skWins: 'Gains',
    skLosses: 'Pertes',
    skWinRate: 'Taux de Gain',
    skWinStreakDist: 'Distribution des Séries de Gains',
    skLossStreakDist: 'Distribution des Séries de Pertes',
    skBarTooltip: '{count} occurrence(s) de {length} {type} consécutifs',
    skBarWinType: 'gains',
    skBarLossType: 'pertes',
    skWinStreakDistDesc:
      'Nombre de fois où chaque longueur de série gagnante est apparue. Une série de 3 = 3 trades gagnants consécutifs.',
    skLossStreakDistDesc:
      'Nombre de fois où chaque longueur de série perdante est apparue. Les longues séries indiquent une sensibilité au régime de marché.',
    skAxisStreakLength: 'Longueur de série',
    skAxisOccurrences: 'Occurrences',

    epochSectionEquity: 'Equity & Drawdowns',
    epochSectionPerformance: 'Performance',
    epochSectionTrades: 'Trades',
    epochSectionRisk: 'Risque & Structure',
    epochSectionConsistency: 'Consistance',

    deleteRun: 'Supprimer le run',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce run ?',
    favorite: 'Favori',
    notes: 'Notes',
    verdictGood: 'Bon',
    verdictCaution: 'Prudence',
    verdictDanger: 'Danger',
    summaryTitle: "Résumé d'analyse",
    validationChecklist: 'Checklist de validation',
    copyCommand: 'Copier la commande',
    commandCopied: 'Commande copiée',
    noMetadata: 'Pas de métadonnées disponibles (run legacy)',

    started: 'Début',
    ended: 'Fin',
    duration: 'Durée',

    totalProfit: 'Profit Total',
    totalTrades: 'Trades Totaux',
    bestSharpe: 'Meilleur Sharpe',
    bestLoss: 'Meilleur Loss',
    hintTotalProfit: 'Profit total de la meilleure epoch en pourcentage du capital initial.',
    hintTotalTrades: 'Nombre total de trades exécutés pendant la meilleure epoch.',
    hintBestSharpe:
      "Ratio de Sharpe de la meilleure epoch. Au-dessus de 1.0 c'est bien, au-dessus de 2.0 c'est excellent.",
    hintBestLoss: 'Valeur de la fonction de perte de la meilleure epoch. Plus négatif = meilleur.',
    bestEpochResults: 'Résultats de la meilleure epoch :',
    epochsCompleted: 'Époques',
    verdictGrade: 'Note',
    nWindows: 'Fenêtres',

    configSaved: 'Config Sauvegardée',
    configCurrent: 'Config Actuelle',
    configChanged: 'La config a changé depuis ce run',
    sourceSaved: 'Code Stratégie Sauvegardé',
    sourceCurrent: 'Code Stratégie Actuel',
    sourceChanged: 'La stratégie a été modifiée depuis ce run',
    fileDeleted: "Le fichier n'existe plus",
    noDiff: 'Aucun changement détecté',
    showDiff: 'Afficher le diff',

    trainRange: 'Plage Train',
    testRange: 'Plage Test',
    trainProfit: 'Profit Train',
    testProfit: 'Profit Test',
    degradation: 'Dégradation',
    windowsTitle: 'Fenêtres Walk-Forward',
    oosTradesLabel: 'Trades OOS',
    noParamsAvailable: 'Aucun paramètre disponible pour ce run.',

    // Bot hors ligne
    botOfflineTitle: 'Bot hors ligne',
    botOfflineDesc:
      "Le bot principal doit être en cours d'exécution pour afficher les backtests, hyperopts et walk-forward. Démarrez le bot et cette page se chargera automatiquement.",

    authRequired: 'Authentification requise',
    authRequiredDesc:
      "Vous devez vous connecter pour accéder au Développement Stratégie. Cette page affiche le code source de vos stratégies, configs et résultats d'optimisation — elle est protégée par le mot de passe de votre bot.",
    authStep1Title: '1. Configurer les identifiants API',
    authStep1Desc:
      'Vérifiez que le fichier de config de votre bot contient une section api_server avec un username et un password :',
    authStep2Title: '2. Se connecter via FreqUI',
    authStep2Desc:
      "Allez dans Paramètres (icône engrenage) et ajoutez votre bot avec l'URL, le nom d'utilisateur et le mot de passe configurés. FreqUI obtient automatiquement un token JWT à la connexion.",
    authStep3Title: '3. Revenir ici',
    authStep3Desc:
      'Une fois connecté, revenez sur cette page. Vos runs se chargeront automatiquement. Si ce message réapparaît, votre session a peut-être expiré — reconnectez-vous.',
    modeNotSupported: 'Fonctionnalité non disponible',
    modeNotSupportedDesc:
      'Les endpoints Strategy Development ne sont pas disponibles sur ce bot. Vérifiez que vous utilisez une version de Freqtrade qui inclut le module API stratdev.',
    endpointNotFound: 'Endpoint introuvable',
    endpointNotFoundDesc:
      "Les endpoints /stratdev n'ont pas été trouvés sur ce bot. Cela signifie généralement que le bot utilise une version ancienne de Freqtrade sans le module Strategy Development. Mettez à jour votre installation et redémarrez le bot.",
    connectionError: 'Connexion échouée',
    connectionErrorDesc:
      "Impossible de se connecter à l'API du bot. Vérifiez que le bot tourne et que FreqUI est configuré avec la bonne URL.",
    errorDetail: 'Erreur {code} : {message}',
    retry: 'Réessayer',

    // Fallbacks sans snapshot
    noSnapshotWarningTitle: 'Snapshot non disponible',
    noSnapshotSourceDesc:
      "Le code source exact utilisé lors de ce run n'a pas été sauvegardé. Le code actuel de la stratégie est affiché à la place.",
    noSnapshotConfigDesc:
      "La config exacte utilisée lors de ce run n'a pas été sauvegardée. La config actuelle du bot est affichée à la place.",
    noSnapshotCommandDesc:
      "La commande exacte n'a pas été sauvegardée. Ceci est une approximation reconstruite à partir des métadonnées disponibles.",
    noSourceAvailable: 'Aucun code source disponible pour ce run.',
    noConfigAvailable: 'Aucune config disponible pour ce run.',
    noCommandAvailable: 'Aucune commande disponible pour ce type de run.',
    commandSaved: 'Commande sauvegardée',
    commandInferred: 'Commande reconstituée',

    copyJson: 'Copier JSON',
    copyAll: 'Tout copier',
    copied: 'Copié !',
    expand: 'Développer',
    collapse: 'Réduire',

    // Sections des graphiques
    sectionOverfitWarnings: 'Alertes de surapprentissage',
    sectionHealthChecks: 'Vérifications de santé',
    sectionProfitRobustness: 'Robustesse du profit',
    sectionMonteCarlo: 'Simulation Monte Carlo',
    sectionConvergenceDistribution: 'Convergence et Distribution',
    sectionParameterAnalysis: 'Analyse des paramètres',
    sectionParameterSensitivity: 'Sensibilité des paramètres',
    sectionWindowPerformance: 'Performance par fenêtre',
    sectionRobustnessAnalysis: 'Analyse de robustesse',
    sectionWarnings: 'Alertes',

    // Alerte aucun trade négatif
    noLosingTradesTitle: 'Aucun trade perdant détecté',
    noLosingTradesDesc:
      "C'est extrêmement inhabituel et indique presque certainement un surapprentissage. Une vraie stratégie de trading aura toujours des trades perdants. L'optimiseur a probablement trouvé des paramètres qui s'ajustent parfaitement au bruit historique plutôt qu'à un véritable avantage. Traitez ces résultats avec une extrême prudence.",
    noLosingTradesAction1: 'Augmenter --hyperopt-min-trades pour exiger plus de trades',
    noLosingTradesAction2:
      'Élargir la plage temporelle pour inclure différentes conditions de marché',
    noLosingTradesAction3:
      'Utiliser la validation walk-forward pour vérifier la performance hors-échantillon',
    noLosingTradesAction4: 'Envisager CalmarHyperOptLoss qui pénalise le drawdown',

    // Titres des graphiques
    chartLossConvergence: 'Convergence du Loss',
    chartLossDistribution: 'Distribution du Loss',
    chartReturnVsDrawdown: 'Rendement vs Drawdown',
    chartPairProfitDistribution: 'Distribution du Profit par Paire',
    chartParallelCoords: 'Coordonnées Parallèles (Top 10)',
    chartParameterCorrelation: 'Corrélation des Paramètres',
    chartMonteCarloTitle: "Monte Carlo — Robustesse à l'ordre des trades",
    hintConvergence:
      "Chaque point est une époque. La ligne verte suit la meilleure loss. Plate à la fin = convergé. En baisse = essayez plus d'époques.",
    hintLossHistogram:
      'Distribution des losses. Vert = top 25%, jaune = milieu, rouge = bas 25%. Votre meilleure loss devrait être dans la zone verte.',
    hintReturnVsDd:
      "Chaque point montre le compromis profit/drawdown d'une époque. Zone verte = profit > 0 et DD < 25%. Plus de points = espace robuste.",
    hintMonteCarlo:
      "Mélange l'ordre des trades pour tester si l'edge dépend de la séquence. P5 positif = rentable dans 95% des ordres (robuste).",
    hintPairProfit:
      'Contribution de chaque paire au profit de la meilleure époque. Une bonne stratégie profite de plusieurs paires, pas une seule.',
    hintParallelCoords:
      'Chaque ligne est une époque. Vert = faible loss, rouge = forte loss. Là où le vert se concentre = zone optimale pour ce paramètre.',
    hintCorrelation:
      'Corrélations entre paramètres sur les meilleurs résultats. Gris (≈0) = indépendants (idéal). Fort rouge/bleu = potentiellement redondants.',
    hintSensitivity:
      "Heatmap de la loss pour deux paramètres. Couleur uniforme = pas d'interaction (robuste). Fort gradient = zone optimale étroite.",
    hintBvm:
      'Compare le profit du meilleur epoch à la médiane du top-10. ≤ 1.5x = cohérent. > 2x = le meilleur epoch est probablement aberrant.',
    hintPrt:
      "Meilleur = valeur du meilleur epoch. Recommandé = médiane du top-5 (plus robuste). Plage top-10 étroite = l'optimiseur converge.",
    hintDispersion:
      'Dispersion des métriques clés sur les top-10 époques. Bande étroite = résultats concordants (robuste). Large = le meilleur epoch peut être aberrant.',
    hintWfe:
      "Efficacité Walk-Forward par fenêtre. > 50% = l'edge se conserve hors échantillon. < 30% = probablement surappris.",
    hintTrainVsTest:
      'Compare le profit in-sample (train) vs out-of-sample (test) par fenêtre. Ratio constant = robuste. Gros écarts = surapprentissage.',
    hintMarketContext:
      'Régime de marché par fenêtre (haussier/baissier/latéral). Explique les variations de performance selon les conditions.',
    chartExportPng: 'Exporter en PNG',
    chartFullscreen: 'Plein écran',
    chartWfe: 'Efficacité Walk-Forward',
    chartTrainVsTest: 'Profit Train vs Test',
    chartMarketContext: 'Contexte de marché par fenêtre',
    wfaWfeTitle: 'Efficacité Walk-Forward',
    wfaTrainVsTestTitle: 'Profit Train vs Test',
    wfaMarketContextTitle: 'Contexte de Marché par Fenêtre',

    // Monte Carlo
    mcProbPositive: 'P(profit > 0)',
    mcRobust: 'Robuste',
    mcMarginal: 'Marginal',
    mcNoEdge: "Pas d'avantage",
    mcSimulations: '{n} simulations',
    mcTrades: '{n} trades',
    mcMedian: 'Médiane (P50)',
    mcMean: 'Moyenne',
    mcIqr: 'IQR (P25-P75)',
    mcWhiskers: 'Moustaches (P5-P95)',
    mcClampWarning:
      'Axe plafonné à ±2000% pour la lisibilité. Les étiquettes montrent les valeurs réelles.',
    mcHowToReadTitle: 'Comment lire ce graphique',
    mcWhatItDoes: "Ce qu'il fait",
    mcWhatItDoesDesc:
      "Mélange l'ordre de vos {trades} trades {sims} fois et calcule le profit final composé à chaque fois. Cela teste si l'avantage de votre stratégie dépend d'une séquence chanceuse de trades ou s'il est véritablement robuste.",
    mcHowToReadBoxPlot: 'Comment lire la boîte à moustaches',
    mcBoxDesc:
      "Les 50% centraux des résultats. Une boîte étroite signifie des résultats constants quel que soit l'ordre des trades.",
    mcMedianDesc:
      "La moitié des simulations se terminent au-dessus de cette valeur, l'autre moitié en dessous. C'est votre résultat « typique ».",
    mcMeanDesc:
      'La moyenne de toutes les simulations. Si bien supérieure à la médiane, quelques ordres chanceux la tirent vers le haut (asymétrie droite).',
    mcWhiskersDesc: 'La plage couvrant 90% des résultats. P5 est votre pire scénario réaliste.',
    mcKeyInsight: 'Point clé : le P5 est ce qui compte le plus',
    mcKeyInsightDesc:
      "Si P5 est positif, votre stratégie est rentable dans 95% des ordres de trades — l'avantage est robuste. Si P5 est négatif mais P50 positif, vous avez un avantage mais il dépend d'un séquencement favorable.",
    mcThresholdTitle: 'Interprétation de P(profit > 0)',
    mcThresholdRobust:
      "≥ 80% — Avantage robuste. Votre stratégie est rentable dans la grande majorité des ordres de trades. L'avantage est réel et ne dépend pas de la chance.",
    mcThresholdMarginal:
      "60% - 80% — Marginal. Il y a probablement un avantage, mais il est sensible à l'ordre des trades. Évaluez si la stratégie a suffisamment de trades ou si l'avantage pourrait être surappris.",
    mcThresholdNoEdge:
      "< 60% — Pas d'avantage fiable. La rentabilité dépend largement de l'ordre des trades. Traitez tout profit de backtest comme du bruit.",

    // Histogramme de Loss
    lhBestLoss: 'Meilleur loss : {value} — bat {pct}% des époques',
    lhSubtitle: 'Votre meilleure loss ({loss}) surpasse {pct}% de toutes les epochs',
    lhExceptional: 'Exceptionnel — top {pct}%',
    lhDecent: 'Correct — mais beaucoup de résultats similaires',
    lhStruggled: "L'optimiseur a eu du mal",
    lhHowToRead: 'Comment lire',
    lhDesc1: "Chaque barre montre combien d'époques sont dans cette plage de loss",
    lhDesc2Green: 'Zone verte',
    lhDesc2Text: ' = top 25% des résultats, ',
    lhDesc2Yellow: 'Jaune',
    lhDesc2Mid: ' = 50% centraux, ',
    lhDesc2Red: 'Rouge',
    lhDesc2End: ' = 25% inférieurs',
    lhDesc3: 'Votre meilleur loss (ligne cyan pointillée) devrait être au fond de la zone verte',
    lhDesc4:
      "Si le percentile ≥ 90% : exceptionnel. 50–90% : correct mais commun. < 50% : l'optimiseur a eu du mal",
    lhInsightConcentrated:
      "{pct}% des epochs sont dans le meilleur quartile — l'optimiseur converge bien vers de bonnes solutions",
    lhInsightSparse:
      "Très peu d'epochs dans la meilleure zone — possible suroptimisation. Le meilleur résultat est peut-être un coup de chance",
    lhInsightOverfit:
      'Seulement 1–2 epochs proches du meilleur loss sur 50+ au total — risque élevé de suroptimisation. Ce résultat est probablement une anomalie',
    lhInsightExcellent:
      "Excellente distribution : le meilleur loss est dans le top 5% ET beaucoup d'epochs sont proches — optimisation robuste",
    lhInsightPeakLow:
      "La concentration maximale est dans la zone de faible loss — l'optimiseur gravite naturellement vers de bonnes solutions",
    lhInsightPeakHigh:
      "La majorité des epochs sont dans la zone de loss élevé — l'espace de recherche est peut-être trop large ou la stratégie est fragile",

    // Analyse de durée
    durAll: 'Tous',
    durWinners: 'Gagnants',
    durLosers: 'Perdants',
    durMinutes: 'Durée',
    durSummary: 'Résumé',
    durByExitReason: 'Par raison de sortie',
    durTrades: 'Trades',
    durAvgProfit: 'Profit moyen',
    durTotalProfit: 'Profit total',
    durWinrate: 'Win Rate',
    durAvgStake: 'Stake moyen',
    durBestBucket: 'Meilleure fenêtre : {label} (moy. {profit}%)',
    durWorstBucket: 'Pire durée : {label} (moy. {profit}%) — envisager un exit forcé temporel',
    durLongNegShortPos:
      'Les positions courtes sont rentables mais les longues perdent — les exits devraient être plus rapides',
    durAllPairs: 'Toutes les paires',
    durDangerZone: '{count} trades ({pct}%) dans la zone de danger : longue durée + grosse perte',
    aaDurationBoxplot: 'Distribution des Durées',
    aaDurationBuckets: 'Performance par Durée',
    aaStuckTrades: 'Analyse des Trades Bloqués',
    aaDurationProfitHeatmap: 'Durée × Profit',
    hintDurationBoxplot:
      'Boîtes à moustaches des durées pour gagnants vs perdants. Les points sont des outliers (positions tenues beaucoup plus longtemps que la normale).',
    hintDurationBuckets:
      "Regroupe les trades par durée de détention. Si les longues durées perdent de l'argent, envisager un exit forcé temporel.",
    hintStuckTrades:
      'Trades détenus >2x la durée médiane. Montre le capital bloqué et les pires cas.',
    hintDurationProfitHeatmap:
      'Croisement durée × profit. Idéalement, la majorité des trades sont dans la zone courte durée + profit positif.',
    stuckCount: 'Trades bloqués',
    stuckPctTrades: '% des trades',
    stuckAvgProfit: 'Profit moyen',
    stuckCapitalBlocked: 'Capital bloqué',
    stuckThreshold: 'Seuil',
    stuckMedian: 'Durée médiane',
    stuckOppCost: "Coût d'opportunité",
    stuckFundingCost: 'Coût funding (est.)',
    stuckPair: 'Paire',
    stuckDuration: 'Durée',
    stuckProfit: 'Profit',
    stuckStake: 'Stake',
    stuckExit: 'Sortie',
    stuckOrders: 'Ordres',

    // Labels métriques partagés
    metricSharpe: 'Sharpe',
    metricSortino: 'Sortino',
    metricCalmar: 'Calmar',
    metricMaxDD: 'DD Max',
    metricProfitFactor: 'Facteur de Profit',
    metricWinRate: 'Taux de Réussite',
    metricTrades: 'Trades',
    metricTotalTrades: 'Total Trades',
    metricTotalProfit: 'Profit Total',
    metricProfit: 'Profit',
    metricProfitPct: 'Profit %',
    metricProfitAbs: 'Profit (abs)',
    metricAvgProfit: 'Profit Moy.',
    metricAvgDuration: 'Durée Moy.',
    metricLoss: 'Loss',
    metricBestLoss: 'Meilleur Loss',
    metricGrade: 'Note',
    metricEpochs: 'Époques',
    metricPF: 'PF',
    metricSQN: 'SQN',
    metricCAGR: 'CAGR',
    metricExpectancy: 'Espérance',
    metricAvgWin: 'Gain Moy.',
    metricAvgLoss: 'Perte Moy.',
    metricPayoffRatio: 'Ratio Gain/Perte',
    metricKelly: 'Kelly %',
    metricHalfKelly: 'Demi Kelly %',
    metricCI95: 'IC 95%',
    metricMean: 'Moyenne',
    metricMedian: 'Médiane',
    metricStdDev: 'Écart Type',
    metricBestTrade: 'Meilleur Trade',
    metricWorstTrade: 'Pire Trade',
    metricVaR95: 'VaR 95%',
    metricCVaR95: 'CVaR 95%',
    metricOmega: 'Omega',
    metricTailRatio: 'Tail Ratio',
    metricUlcerIndex: 'Ulcer Index',
    metricRecoveryFactor: 'Facteur de Récupération',
    metricGainPain: 'Gain/Douleur',
    metricTradesPerDay: 'Trades/Jour',
    metricDays: 'Jours',
    metricTimeframe: 'Timeframe',
    metricFinalBalance: 'Solde Final',
    metricDrawdown: 'Drawdown',
    metricDSR: 'DSR',
    metricOOSTrades: 'Trades OOS',
    metricOOSSQN: 'SQN OOS',
    metricOOSExpectancy: 'Espérance OOS',
    metricOOSProfit: 'Profit OOS',
    metricKRatio: 'K-Ratio',
    metricCarverDiscount: 'Remise Carver',

    // Séries / axes graphiques
    seriesStrategy: 'Stratégie',
    seriesBuyHold: 'Buy & Hold',
    seriesCumulativePct: 'Cumulé %',
    seriesBalance: 'Solde',
    seriesTradePnL: 'P&L Trade',
    seriesTrain: 'Entraînement',
    seriesTest: 'Test',
    seriesWinners: 'Gagnants',
    seriesLosers: 'Perdants',
    seriesActual: 'Réel',
    seriesNormalFit: 'Ajustement normal',
    axisDuration: 'Durée (min)',
    axisProfit: 'Profit %',
    axisWindow: 'Fenêtre',
    axisWFE: 'WFE',
    axisRatio: 'Ratio',
    axisVolatility: 'Volatilité',
    axisPath: 'Chemin',
    axisReturnPct: 'Rendement %',
    seriesBTCChange: 'Variation BTC',
    seriesVolatility: 'Volatilité',
    seriesTradeEntry: 'Entrée trade',
    seriesTradeExit: 'Sortie trade',
    seriesVolume: 'Volume',
    seriesRollingSharpe: 'Sharpe glissant ({window}j)',
    seriesRollingSortino: 'Sortino glissant ({window}j)',
    seriesRollingVolatility: 'Volatilité glissante ({window}j)',
    chartCPCVPathReturns: 'Rendements des chemins CPCV',
    signalEntryLong: 'Entrée Long',
    signalExitLong: 'Sortie Long',
    signalEntryShort: 'Entrée Short',
    signalExitShort: 'Sortie Short',
    metricEpochNum: 'Epoch #{n}',
    metricRank: 'Rang',

    // Colonnes de tableau
    columnPair: 'Paire',
    columnRank: '#',
    columnDepth: 'Profondeur',
    columnStart: 'Début',
    columnValley: 'Creux',
    columnEnd: 'Fin',
    columnDecline: 'Déclin',
    columnRecovery: 'Récupération',
    columnTotal: 'Total',
    columnPeriod: 'Période',

    // Labels UI
    statusActive: 'Actif',
    copied: 'Copié !',
    copy: 'Copier',
    viewTree: 'Arbre',
    viewRaw: 'Brut',
    formatJSON: 'JSON',
    formatTable: 'Tableau',
    noWarnings: 'Aucun avertissement',
    sortDate: 'Date',
    sortProfit: 'Profit',
    sortLoss: 'Loss',
    sortGrade: 'Note',
    favoritesOnly: 'Favoris uniquement',
    favorites: 'Favoris',
    collapseSidebar: 'Réduire la barre latérale',
    expandSidebar: 'Développer la barre latérale (Ctrl+K)',
    sortBy: 'Trier par {metric}',
    exportParams: 'Exporter params JSON',
    sqnSuperb: 'Superbe',
    sqnExcellent: 'Excellent',
    sqnGood: 'Bon',
    sqnAverage: 'Moyen',
    sqnBelowAvg: 'Sous la moy.',
    sqnPoor: 'Médiocre',

    // Corrélation inter-paires
    aaPairCorrelation: 'Matrice de Corrélation des Paires',
    aaConcentrationRisk: 'Risque de Concentration',
    aaMaxSimultaneousLoss: 'Perte Simultanée Max',
    hintPairCorrelation:
      'Corrélation entre les P&L quotidiens de chaque paire. Une forte corrélation signifie que les paires évoluent ensemble — le bénéfice de diversification est limité.',
    hintConcentrationRisk:
      "Mesure la concentration des profits sur les paires. L'indice HHI quantifie la diversification (plus bas = plus diversifié).",
    hintMaxSimultaneousLoss:
      'Pire scénario : la perte maximale survenant sur plusieurs positions simultanément.',
    corrHighlyCorrelated: 'Paires Fortement Corrélées',
    corrAvgCorrelation: 'Corrélation Moy.',
    corrHhi: 'Indice HHI',
    corrTopPair: 'Paire Principale',
    corrHighPairs: 'Paires Corr. Élevées',
    corrDiversified: 'Diversifié',
    corrModerate: 'Modéré',
    corrConcentrated: 'Concentré',
    corrVolumeShare: 'Part du Volume',
    corrMaxLoss: 'Perte Max',
    corrLossDate: 'Date',
    corrLossCount: 'Positions',
    corrLossPairs: 'Paires',
    concHhi: 'Indice HHI',
    concTopPair: 'Paire Principale',
    concAvgCorr: 'Corrélation Moy.',
    concHighCorrCount: 'Paires Corr. Élevées',
    concVolumeDistribution: 'Distribution du Volume',
    mslMaxLoss: 'Perte Max',
    mslPositions: 'Positions',
    mslDate: 'Date',
    mslPairsInvolved: 'Paires Impliquées',

    // Analyse DCA
    aaDcaDistribution: 'Distribution des Niveaux DCA',
    aaDcaProfitContribution: 'Contribution DCA au Profit',
    aaDcaRecovery: 'Analyse de Récupération DCA',
    hintDcaDistribution:
      'Combien de trades atteignent chaque niveau DCA (Base, SO1, SO2...). Coloré par taux de réussite. Une stratégie DCA saine a la majorité des trades se fermant à la base ou SO1.',
    hintDcaProfitContribution:
      'Compare le profit des trades à entrée unique vs les trades DCA multi-entrées. Montre si le DCA améliore réellement les résultats.',
    hintDcaRecovery:
      'Taux de récupération des trades DCA — quel pourcentage de trades ayant nécessité des ordres de sécurité ont fini rentables.',
    dcaNoDca: 'Pas de DCA détecté — tous les trades ont utilisé une seule entrée',
    dcaAvgEntries: 'Entrées Moy.',
    dcaRecoveryRate: 'Taux de Récupération',
    dcaDcaTrades: 'Trades DCA',
    dcaSingleAvg: 'Moy. Entrée Simple',
    dcaMultiAvg: 'Moy. Multi-Entrée',
    dcaSingleEntry: 'Entrée simple',
    dcaMultiEntry: 'Multi-entrée (DCA)',
    dcaProfitContrib: 'Contribution au Profit',
    dcaAvgProfit: 'Profit Moy.',
    dcaPair: 'Paire',
    dcaAvgEntriesCol: 'Entrées Moy.',
    dcaTrades: 'Trades',
    dcaHighRecovery: 'Récupération DCA efficace (>{pct}%)',
    dcaLowRecovery: "Faible récupération DCA — les ordres de sécurité n'aident pas",
    dcaImprovesProfit: 'Le DCA améliore le profit moyen',
    dcaDegradesProfit: 'Le DCA dégrade le profit moyen',
    dcaDeepLosing: 'Les niveaux DCA profonds (6+) sont majoritairement perdants',
    dcaCount: 'Nombre',
    dcaWinRate: 'Taux de Réussite',
    dcaAvgDuration: 'Durée Moy.',
    dcaAvgStake: 'Mise Moy.',
    dcaTradeCount: 'Nombre de Trades',
    dcaSingleEntryAvg: 'Moy. Entrée Simple',
    dcaMultiEntryAvg: 'Moy. Multi-Entrée',

    // Analyse des Régimes de Marché
    aaRegimePerformance: 'Performance par Régime',
    aaRegimeTimeline: 'Timeline des Régimes',
    aaRegimeTransitions: 'Transitions de Régime',
    hintRegimePerformance:
      'Performance de la stratégie par régime de marché. Révèle si la stratégie est « tout-temps » ou dépendante de conditions spécifiques.',
    hintRegimeTimeline:
      'Timeline montrant quel régime était actif à chaque moment. Les couleurs de fond indiquent le régime détecté, la ligne montre la volatilité.',
    hintRegimeTransitions:
      "Probabilité de transition d'un régime à un autre. Aide à anticiper les conditions de marché à venir.",
    regimeBullQuiet: 'Hausse Calme',
    regimeBullVolatile: 'Hausse Volatile',
    regimeBearQuiet: 'Baisse Calme',
    regimeBearVolatile: 'Baisse Volatile',
    regimeDailyView: 'P&L Quotidien',
    regimeTradeView: 'Par Trade',
    regimeAvgProfit: 'Profit Moy.',
    regimeWinrate: 'Win Rate',
    regimeDays: 'Jours',
    regimePctTime: '% du Temps',
    regimeTransitionMatrix: 'Probabilités de Transition',
    regimeDependent: 'La performance dépend du régime de marché',
    regimeVulnerableBear: 'Vulnérable en conditions baissières volatiles',
    regimeAllWeather: 'Stratégie tout-temps — rentable dans tous les régimes',
    regimeVolatility: 'Volatilité',
    regimeTrend: 'Tendance',
    regimeAvgDailyProfit: 'Profit Quotidien Moy.',
    regimeTotalProfit: 'Profit Total',
    regimeTrades: 'Trades',
    regimeFromTo: 'De \\ Vers',
    regimeTimeInEach: 'Temps par régime',
    regimeInsights: 'Observations',
    regimeEquity: 'Équité',
    regimeShowOverlay: 'Régimes',
    regimeTimeline: 'Timeline des Régimes',

    // Bandes de dispersion
    dispersionTitle: 'Dispersion Top-10',
    dispersionProfit: 'Profit',
    dispersionDrawdown: 'Drawdown',
    dispersionSharpe: 'Sharpe',
    dispersionNarrow: 'étroite',
    dispersionModerate: 'modérée',
    dispersionWide: 'large',
    dispersionConsistent: 'Consistant — les résultats du top-10 sont serrés. Optimisation robuste.',
    dispersionModerateAdvisory: "Dispersion modérée — vos résultats varient selon l'époque choisie",
    dispersionHighVariance:
      "Forte variance — les résultats sont très sensibles au choix d'époque. Privilégiez la médiane plutôt que le meilleur.",
    dispersionHowToRead:
      'Montre la dispersion des métriques clés sur vos 10 meilleures époques. Une bande étroite signifie que tous les top résultats concordent (robuste). Une bande large signifie que la « meilleure » époque peut être aberrante — la médiane est plus fiable.',

    // Profit par paire
    pairProfitPairsWithTrades: '{traded}/{total} paires avec des trades',
    pairProfitShowAll: 'Afficher toutes les paires',
    pairProfitSingleInstrument:
      'La stratégie ne fonctionne que sur un seul instrument ({pair}). Très fragile.',
    pairProfitConcentration: 'Forte concentration : {pair} représente {pct}% du profit total.',
    pairProfitHowToReadTitle: 'Comment lire ce graphique',
    pairProfitDesc1: 'Montre la contribution au profit par paire de la meilleure époque',
    pairProfitDesc2: 'Vert = profit positif, Rouge = profit négatif',
    pairProfitDesc3: 'Le nombre entre parenthèses = nombre de trades pour cette paire',
    pairProfitDesc4: "Une bonne stratégie profite de plusieurs paires, pas d'une seule",

    // Coordonnées parallèles
    pcBestEpoch: 'Meilleure époque (loss : {loss}) :',
    pcBestLowLoss: 'Meilleur (loss faible)',
    pcWorstHighLoss: 'Pire (loss élevé)',
    pcHowToReadTitle: 'Comment lire ce graphique',
    pcDesc1: 'Chaque axe vertical = un paramètre (bas = minimum, haut = maximum)',
    pcDesc2: "Chaque ligne = la combinaison de paramètres d'une époque",
    pcDesc3: 'Lignes vertes = loss faible (bon), Lignes rouges = loss élevé (mauvais)',
    pcDesc4: 'Là où les lignes vertes se regroupent = zone optimale pour ce paramètre',
    pcDesc5:
      "Si les lignes vertes et rouges se chevauchent sur un axe, ce paramètre a peu d'impact",
    pcQualityMap: 'Carte de qualité des paramètres',
    pcQualityGood: 'Bon (loss faible)',
    pcQualityMedium: 'Moyen',
    pcQualityBad: 'Mauvais (loss élevée)',
    pcQualityNoData: 'Pas de données',
    pcQualityBest: 'Meilleure epoch',
    pcQualityMedian: 'Médiane',

    // Heatmap de corrélation
    corrRedundant:
      'Certains paramètres ont |r| > 0.7 — envisagez de fusionner ou supprimer les paramètres redondants',
    corrIndependent: 'Toutes les corrélations < 0.3 — chaque paramètre contribue indépendamment',
    corrModerate: 'Max |r| = {val} — corrélations modérées, généralement acceptable',
    corrCoeff: 'Corrélation',
    corrStrength: 'Force',
    corrWeak: 'Faible',
    corrMod: 'Modérée',
    corrStrong: 'Forte',
    corrHowToReadTitle: 'Comment lire ce graphique',
    corrDesc:
      "Montre comment les paramètres sont liés entre eux à travers les meilleurs résultats d'optimisation.",
    corrGray: 'Gris (proche de 0)',
    corrGrayDesc: ' = idéal — paramètres indépendants.',
    corrBlue: 'Bleu (négatif, |r| > 0.7)',
    corrBlueDesc: " = relation inverse — quand l'un monte, l'autre descend.",
    corrRed: 'Rouge (positif, |r| > 0.7)',
    corrRedDesc: ' = évoluent ensemble — potentiellement redondants.',

    // Grille de sensibilité
    sensWeakInteraction: 'Interaction faible — le loss est stable entre les combinaisons (robuste)',
    sensStrongInteraction:
      'Interaction forte — la zone optimale peut être étroite, ajustez-les ensemble',
    sensModerateInteraction: 'Interaction modérée (CV = {cv}%)',
    sensNotEnoughData: "Pas assez de données pour évaluer la force d'interaction",
    sensHowToReadTitle: 'Comment lire ce graphique',
    sensDesc1: 'Montre comment le loss change quand deux paramètres varient simultanément.',
    sensGreen: 'Cellules vertes',
    sensGreenDesc: ' = loss faible (bonnes combinaisons de paramètres).',
    sensRed: 'Cellules rouges',
    sensRedDesc: ' = loss élevé (mauvaises combinaisons de paramètres).',
    sensFlat: 'Couleur uniforme',
    sensFlatDesc: " = les paramètres n'interagissent pas (robuste).",
    sensGradient: 'Motif/gradient marqué',
    sensGradientDesc:
      ' = les paramètres interagissent fortement — la zone optimale peut être étroite.',
    sensPattern: 'Motif/gradient fort',
    sensPatternDesc:
      ' = les paramètres interagissent fortement — la zone optimale peut être étroite.',
    sensEmpty: 'Cellules vides',
    sensEmptyDesc: " = aucune époque n'a testé cette combinaison.",

    // Convergence
    convConverged: "Plateau de loss atteint — l'optimiseur a convergé.",
    convNotConverged:
      "Encore en amélioration dans les derniers 30%. Envisagez de lancer plus d'époques.",
    convHowToReadTitle: 'Comment lire ce graphique',
    convDesc1: "Chaque point gris = la loss d'un epoch, affiché dans l'ordre chronologique",
    convDesc2:
      "La ligne verte suit la meilleure loss observée jusqu'ici — elle ne peut que descendre",
    convDesc3: "Une ligne verte plate à la fin = l'optimiseur a convergé (bien)",
    convDesc4:
      "Si la ligne verte descend encore à la fin, vous pourriez bénéficier de plus d'époques",
    convDesc5: 'Le losange cyan marque le meilleur epoch global',

    // Rendement vs DD
    rvddIdealZone: '{count}/{total} époques dans la zone idéale (profit > 0, DD < 25%)',
    rvddBest: 'Meilleur : {profit}% profit, {dd}% DD',
    rvddHowToReadTitle: 'Comment lire ce graphique',
    rvddDesc1: "Chaque point = le compromis rendement/drawdown d'une époque",
    rvddDesc2: 'Zone verte = zone idéale (profit > 0, DD < 25%)',
    rvddDesc3: 'Point cyan = meilleure époque (loss le plus bas)',
    rvddDesc4: 'Beaucoup de points dans la zone verte = espace paramétrique robuste',
    rvddDesc5:
      'Peu de points dans la zone verte = zone viable étroite, risque de surapprentissage accru',

    // Best vs Median
    bvmTitle: 'Meilleur vs. Médiane Top-10',
    bvmBestEpoch: 'Meilleure Époque',
    bvmMedianTop10: 'Médiane Top-10',
    bvmGapRatio: "Ratio d'écart",
    bvmConsistent: 'Consistant',
    bvmModerateGap: 'Écart modéré',
    bvmOutlier: 'Aberrant — chance, pas compétence',
    bvmHowToRead: 'Comment lire',
    bvmDesc1: 'Compare le profit de votre meilleure époque à la médiane des 10 meilleures.',
    bvmDesc2: '≤ 1.5x = consistant — le meilleur est proche du groupe (vert).',
    bvmDesc3: "1.5x - 2x = écart modéré — certaine dépendance à l'époque (jaune).",
    bvmDesc4:
      '> 2x = aberrant — la meilleure époque est un accident statistique. Faites confiance à la médiane (rouge).',

    // Carte DSR
    dsrTitle: 'Ratio de Sharpe Déflaté',
    dsrObservedSharpe: 'Sharpe Observé',
    dsrExpectedMaxSR: 'E[max SR]',
    dsrExpectedMax: 'E[max SR]',
    dsrNTrials: 'N Essais',
    dsrGenuine: 'Authentique',
    dsrOverfitted: 'Surappris',
    hintDsr:
      'Le Deflated Sharpe Ratio (DSR) teste si le Sharpe observé est statistiquement significatif étant donné le nombre d\'essais. Si le DSR indique "Overfitted", le Sharpe pourrait être dû au hasard.',

    // Carte DOF
    dofTitle: 'Degrés de Liberté',
    dofCritical: 'Critique (5)',
    dofExcellent: 'Excellent (30+)',
    dofTradesLabel: 'trades',
    dofTradesParams: '{trades} trades / {params} params',
    dofParamsLabel: 'params',
    hintDof:
      'Les degrés de liberté mesurent le ratio trades/paramètres optimisés. Plus de trades par paramètre = optimisation plus fiable. En dessous de 10:1 est préoccupant, au-dessus de 20:1 est excellent.',

    // Carte Distribution
    distTitle: 'Distribution des Rendements',
    distSkewness: 'Asymétrie',
    distHeavyLeftTail: 'Queue gauche lourde',
    distKurtosis: 'Kurtosis en excès',
    distFatTails: 'Queues épaisses',
    distTrades: 'Trades',

    // Carte Sans Top Trade
    sttTitle: 'Concentration du Profit',
    sttTotalProfit: 'Profit Total',
    sttAllTrades: 'Tous les Trades',
    sttWithoutTop1: 'Sans Top 1',
    sttWithoutTop2: 'Sans Top 2',
    sttFragile: 'Fragile',
    sttDiversified: 'Diversifié',

    // Carte Analyse de Régime
    raTitle: 'Analyse de Régime',
    raTrades: 'Trades',
    raProfit: 'Profit',
    raWinRate: 'Taux de Gain',
    raAvgProfit: 'Profit Moyen',
    raConsistent: 'Consistant',
    raInconsistent: 'Inconsistant',
    raFirstHalf: 'Première moitié',
    raSecondHalf: 'Seconde moitié',

    // Carte Benchmark
    bmTitle: 'Comparaison au Benchmark',
    bmSharpe: 'Sharpe',
    bmMaxDD: 'Max DD',
    bmAbove: 'au-dessus',
    bmBelow: 'en dessous',
    bmHealthy: 'sain',
    bmHigh: 'élevé',

    // Code Viewer
    cvLines: '{n} lignes',
    cvCopied: 'Copié',
    cvCopy: 'Copier',
    cvSearch: 'Rechercher (Ctrl+F)',
    cvSearchPlaceholder: 'Rechercher dans le code...',
    cvNoResults: 'Aucun résultat',
    cvFontSmaller: 'Réduire la taille',
    cvFontLarger: 'Augmenter la taille',
    cvFoldAll: 'Tout replier',
    cvUnfoldAll: 'Tout déplier',
    cvFoldedLines: 'lignes masquées',

    // Panel Paramètres
    ppBestEpochTag: 'Meilleure Époque',
    ppConsensusTag: 'Consensus',
    ppSnapshotTag: 'Snapshot',
    ppSpace: 'Espace',
    ppParameter: 'Paramètre',
    ppValue: 'Valeur',
    ppTop5Median: 'Médiane Top-5',
    ppTop10Median: 'Médiane Top-10',
    ppRecommended: 'Recommandé',

    // Panel Commande
    cmdMultiLine: 'Multi-ligne',
    cmdMonoLine: 'Mono-ligne',
    cmdClickToCopy: 'Cliquer pour copier',

    // Comparaison
    tabCompare: 'Comparer',
    tabTimeline: 'Chronologie',
    compareTitle: 'Comparer les runs',
    compareDesc: 'Sélectionnez un run à comparer avec le run actuel',
    compareSearchPlaceholder: 'Rechercher un run...',
    compareMetrics: 'Comparaison des métriques',
    compareMetric: 'Métrique',
    compareDelta: 'Delta (A-B)',
    compareParams: 'Paramètres',
    compareChanged: 'modifiés',
    compareUnchanged: 'paramètres identiques',
    timelineTitle: 'Historique des Runs',
    timelineToday: "Aujourd'hui",
    timelineYesterday: 'Hier',
    timelineEmpty: 'Aucun run pour le moment',

    // Aperçu Hyperopt
    hoLossFunction: 'Fonction de Loss',
    hoBestParameters: 'Meilleurs Paramètres',
    hoBestEpochMetrics: 'Meilleure Époque — Toutes les Métriques',

    // Tableau Top 10
    t10Title: 'Top 10 Époques',
    t10Rank: '#',
    t10Loss: 'Loss',
    t10Profit: 'Profit %',
    t10Trades: 'Trades',
    t10Sharpe: 'Sharpe',
    t10DD: 'DD %',
    t10WinRate: 'Gain %',
    t10Parameters: 'Paramètres',
    t10ViewMetrics: 'Voir les métriques du backtest',
    t10EpochMetrics: "Métriques du Backtest de l'Époque",

    // WFA Aperçu
    wfaVerdict: 'Verdict Walk-Forward',
    wfaVerdictChecks: 'Vérifications du Verdict',

    // WFA Graphiques
    wfaNoData: 'Aucune donnée WFA disponible.',

    // WFA Cartes
    wfaOosEquity: "Courbe d'Équité OOS",
    wfaTotalReturn: 'Rendement Total',
    wfaMaxDD: 'Max DD',
    wfaKRatio: 'K-Ratio',
    wfaTrades: 'Trades',
    wfaHoldout: 'Validation Holdout',
    wfaPerturbation: 'Perturbation des Paramètres',
    wfaPerturbProfitP50: 'Profit P50',
    wfaPerturbP5: 'P5 (pire)',
    wfaPerturbP95: 'P95 (meilleur)',
    wfaMonteCarlo: 'Monte Carlo (OOS)',
    wfaCarverDiscount: 'Remise Carver',
    wfaDdPercentiles: 'Percentiles de Drawdown',
    wfaAvgReturn: 'Rendement Moyen',
    wfaSharpePaths: 'Sharpe des Chemins',
    wfaCombinations: 'Combinaisons',
    wfaPaths: 'Chemins',
    wfaCpcvTitle: 'CPCV (Validation croisée combinatoire purgée)',
    wfaParamStability: 'Stabilité des Paramètres',
    wfaParamName: 'Paramètre',
    wfaParamMedian: 'Médiane',
    wfaParamStd: 'Écart-type',
    wfaParamStatus: 'Statut',
    wfaParamValues: 'Valeurs',
    wfaRegimeTitle: 'Analyse de Régime',
    wfaRegimeProfit: 'Profit',
    wfaRegimeTrades: 'Trades',
    wfaRegimeWinRate: 'Taux de Gain',
    wfaRegimeSharpe: 'Sharpe',
    wfaDegradationTitle: 'Dégradation par Fenêtre',
    wfaDegWindow: 'Fenêtre',
    wfaDegTrainProfit: 'Profit Train',
    wfaDegTestProfit: 'Profit Test',
    wfaDegProfit: 'Dég. Profit',
    wfaDegSharpe: 'Dég. Sharpe',
    wfaDegCalmar: 'Dég. Calmar',

    // WFA clés supplémentaires
    wfaWindow: 'Fenêtre',
    wfaTrainProfit: 'Profit Entraînement',
    wfaTestProfit: 'Profit Test',
    wfaStd: 'Écart-type',
    wfaStdRange: 'Plage',
    wfaStatus: 'Statut',
    wfaValues: 'Valeurs',
    wfaStable: 'Stable',
    wfaMixed: 'Mixte',
    wfaUnstable: 'Instable',
    wfaParamStabilityTitle: 'Analyse de Stabilité des Paramètres',
    wfaPerturbTitle: 'Analyse de Perturbation',
    wfaPerturbations: '{n} perturbations testées',
    wfaHoldoutTitle: 'Validation Holdout',
    wfaOosEquityTitle: 'Equity Hors-Échantillon',
    wfaRegimeDependent: 'Stratégie dépendante du régime',
    wfaRegimeRobust: 'Stratégie robuste aux régimes',
    wfaWorstRegime: 'Pire régime : {regime}',
    wfaMcTitle: 'Simulation Monte Carlo',
    wfaMcDdPercentiles: 'Percentiles de Drawdown',
    wfaMcReturnDdRatio: 'Ratio Rendement / Drawdown',

    // En-tête détail run
    rdhFavorite: 'Favori',
    rdhNotes: 'Notes',
    rdhClickToEdit: 'Cliquer pour modifier',
    rdhAddNotes: 'Ajouter des notes...',
    rdhSave: 'Enregistrer',
    rdhCancel: 'Annuler',

    // Tableau de recommandations paramètres
    prtTitle: 'Recommandations de Paramètres',
    prtParam: 'Paramètre',
    prtType: 'Type',
    prtBest: 'Meilleur',
    prtRecommended: 'Rec.',
    prtMedian: 'Médiane',
    prtSearchRange: 'Plage de Recherche',
    prtTop10Range: 'Plage Top-10',
    prtDistribution: 'Distribution',
    prtBpFullRange: 'Plage complète',
    prtBpMean: 'Moyenne',
    prtTendency: 'Tendance',
    prtSensitivity: 'Sensibilité',
    prtReasoning: 'Analyse',
    prtConverging: 'Convergent',
    prtBoundary: 'Cluster en bordure',
    prtSpread: 'Dispersé',
    prtStable: 'Stable',
    prtUnstable: 'Instable',
    prtSensHigh: 'Haute',
    prtSensMedium: 'Moyenne',
    prtSensLow: 'Basse',
    prtReasonConverging:
      'Les valeurs top-10 convergent vers une plage étroite — zone optimale claire',
    prtReasonBoundary:
      "Les valeurs se regroupent en bordure de plage — envisagez d'étendre l'espace de recherche",
    prtReasonSpread: "Les valeurs top-10 sont dispersées sur toute la plage — pas d'optimum clair",
    prtReasonHighSens: 'La loss est très sensible à ce paramètre — ajustez avec précaution',
    prtReasonLowSens: 'La loss varie à peine avec ce paramètre — envisagez de le fixer',
    prtReasonStable: 'Stable dans les meilleurs epochs — valeur fiable',
    prtReasonUnstable: 'Varie fortement entre les meilleurs epochs — peu fiable',
    prtSummaryAllClear:
      'Tous les paramètres convergent — optimisation robuste. Les valeurs recommandées sont fiables.',
    prtSummaryMostSpread:
      "La plupart des paramètres sont dispersés — l'optimiseur n'a pas trouvé d'optimum clair. Envisagez de réduire l'espace de recherche ou d'ajouter plus d'epochs.",
    prtSummaryMixed:
      '{converging}/{total} paramètres convergent, {spread} sont dispersés — examinez attentivement les paramètres dispersés.',
    prtHowToReadTitle: 'Comment lire ce tableau',
    prtHowToRead1:
      '"Meilleur" est la valeur du meilleur epoch. "Rec." est la médiane des top-5 epochs — plus robuste que le seul meilleur.',
    prtHowToRead2:
      '"Plage Top-10" montre combien ce paramètre varie dans les meilleurs résultats. Une plage étroite signifie que l\'optimiseur s\'accorde sur une valeur.',
    prtHowToRead3:
      '"Tendance: Convergent" signifie que les valeurs top-10 se regroupent étroitement (bien). "Cluster en bordure" signifie qu\'elles atteignent une limite de l\'espace de recherche — essayez de l\'élargir.',
    prtHowToRead4:
      '"Sensibilité: Haute" signifie que de petits changements de ce paramètre affectent significativement la loss — il compte beaucoup. "Basse" signifie qu\'il compte à peine — vous pourriez le fixer à n\'importe quelle valeur raisonnable.',

    // Pas d'analyse
    noAnalysisData:
      "Aucune donnée d'analyse disponible. Le fichier .fthypt n'existe peut-être pas.",

    // Étiquettes
    median: 'Médiane',
    min: 'Min',
    max: 'Max',
    stable: 'stable',
    unstable: 'instable',
    marginal: 'marginal',
  },

  // Column Editor
  columnEditor: {
    title: 'Colonnes',
    reset: 'Réinitialiser par défaut',
  },

  // Trading mode filter
  tradingModeFilter: {
    allModes: 'Tous les modes',
    liveOnly: 'Live uniquement',
    dryOnly: 'Dry uniquement',
  },

  // Widget Defaults
  widgetDefaults: {
    saveAsDefault: 'Filtre par défaut',
    saved: 'Filtres sauvegardés',
  },

  // Boot splash (shown briefly between page load and the first paint of the dashboard)
  boot: {
    connecting: 'Connexion aux bots…',
    botsLoaded: '{loaded} / {total} bots chargés…',
    preparingDashboard: 'Préparation du tableau de bord…',
  },
};
